'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var util = require('util');

var fetch = require('cross-fetch');

var fetch__default = _interopDefault(fetch);

var queryString = require('query-string');

var Url = require('url');

var lodash = require('lodash');
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */


var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

function __values(o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
      i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}

function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
} // Copyright 2019 Cognite AS

/** @hidden */


var API_VERSION = 'v1';
/** @hidden */

var BASE_URL = 'https://api.cognitedata.com';
/** @hidden */

var AUTHORIZATION_HEADER = 'Authorization';
/** @hidden */

var API_KEY_HEADER = 'api-key';
/** @hidden */

var X_CDF_APP_HEADER = 'x-cdp-app';
/** @hidden */

var X_CDF_SDK_HEADER = 'x-cdp-sdk';
/** @hidden */

var X_REQUEST_ID = 'X-Request-Id'; // Copyright 2019 Cognite AS

var CogniteLoginError =
/** @class */
function (_super) {
  __extends(CogniteLoginError, _super);

  function CogniteLoginError(message) {
    var _this = _super.call(this, message || 'Not able to login') || this;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, _this.constructor);
    } else {
      _this.stack = new Error(_this.message).stack;
    }

    return _this;
  }

  return CogniteLoginError;
}(Error); // Copyright 2019 Cognite AS

/** @hidden */


function getBaseUrl(baseUrl) {
  return baseUrl || BASE_URL;
}
/** @hidden */


var apiUrl = function apiUrl() {
  return "/api/" + API_VERSION;
};
/** @hidden */


function projectUrl(project) {
  return apiUrl() + "/projects/" + encodeURIComponent(project);
}
/** @hidden */


function bearerString(token) {
  return "Bearer " + token;
}
/** @hidden */


function removeQueryParameterFromUrl(url, parameter) {
  return url.replace(new RegExp('[?&]' + parameter + '=[^&#]*(#.*)?$'), '$1').replace(new RegExp('([?&])' + parameter + '=[^&]*&'), '$1');
}
/** @hidden */


function isJson(data) {
  return (lodash.isArray(data) || lodash.isObject(data)) && !util.isBuffer(data) && !(data instanceof Date);
}
/** @hidden */


function sleepPromise(durationInMs) {
  return new Promise(function (resolve) {
    setTimeout(resolve, durationInMs);
  });
}
/** @hidden */


function promiseCache(promiseFn) {
  var unresolvedPromise = null;
  return function () {
    if (unresolvedPromise) {
      return unresolvedPromise;
    }

    return unresolvedPromise = promiseFn().then(function (res) {
      unresolvedPromise = null;
      return res;
    });
  };
}
/** @hidden */


function isSameProject(project1, project2) {
  return project1.toLowerCase() === project2.toLowerCase();
}
/** @hidden */


function applyIfApplicable(args, action) {
  if (action) {
    return action(args);
  }

  return args;
}
/** @hidden */


function transformDateInRequest(data) {
  return lodash.cloneDeepWith(data, function (value) {
    if (value instanceof Date) {
      return value.getTime();
    }
  });
}
/** @hidden */


function transformDateInResponse(data) {
  var dateKeys = ['createdTime', 'lastUpdatedTime', 'uploadedTime', 'deletedTime', 'timestamp'];
  return lodash.cloneDeepWith(data, function (value, key) {
    if (dateKeys.indexOf('' + key) !== -1) {
      return new Date(value);
    }
  });
}
/** @hidden */


function generatePopupWindow(url, name) {
  return window.open(url, name, // https://www.quackit.com/javascript/popup_windows.cfm
  'height=500,width=400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes');
}
/** @hidden */


function createInvisibleIframe(url, name) {
  var iframe = document.createElement('iframe');
  iframe.name = name;
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  iframe.style.border = 'none';
  iframe.src = url;
  return iframe;
} // Copyright 2019 Cognite AS


var ACCESS_TOKEN_PARAM = 'access_token';
var ID_TOKEN_PARAM = 'id_token';
var ERROR_PARAM = 'error';
var ERROR_DESCRIPTION_PARAM = 'error_description';
var LOGIN_IFRAME_NAME = 'cognite-js-sdk-auth-iframe';
var LOGIN_POPUP_NAME = 'cognite-js-sdk-auth-popup';
/** @hidden */

function getIdInfoFromAccessToken$$1(httpClient, accessToken) {
  var _a;

  return getIdInfo$$1(httpClient, (_a = {}, _a[AUTHORIZATION_HEADER] = bearerString(accessToken), _a));
}
/** @hidden */


function loginSilently$$1(httpClient, params) {
  return __awaiter(this, void 0, void 0, function () {
    var project, tokens, _a, baseUrl, href, tokens, _1;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          if (isAuthIFrame()) {
            // don't resolve when inside iframe (we don't want to do any logic)
            return [2
            /*return*/
            , new Promise(function () {})];
          }

          project = params.project;
          tokens = extractTokensFromUrl();
          _a = tokens !== null;
          if (!_a) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , isTokensValid$$1(httpClient, project, tokens)];

        case 1:
          _a = _b.sent();
          _b.label = 2;

        case 2:
          if (_a) {
            clearParametersFromUrl(ACCESS_TOKEN_PARAM, ID_TOKEN_PARAM);
            return [2
            /*return*/
            , tokens];
          }

          baseUrl = params.baseUrl;
          _b.label = 3;

        case 3:
          _b.trys.push([3, 5,, 6]);

          href = window.location.href;
          return [4
          /*yield*/
          , silentLogin({
            baseUrl: baseUrl,
            project: project,
            redirectUrl: href,
            errorRedirectUrl: href
          })];

        case 4:
          tokens = _b.sent();

          if (tokens !== null) {
            return [2
            /*return*/
            , tokens];
          }

          return [3
          /*break*/
          , 6];

        case 5:
          _1 = _b.sent();
          return [3
          /*break*/
          , 6];

        case 6:
          return [2
          /*return*/
          , null];
      }
    });
  });
}
/** @hidden */


function getIdInfo$$1(httpClient, headers) {
  return __awaiter(this, void 0, void 0, function () {
    var response, _a, loggedIn, user, project, projectId, err_1;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 2,, 3]);

          return [4
          /*yield*/
          , httpClient.get('/login/status', {
            headers: headers
          })];

        case 1:
          response = _b.sent();
          _a = response.data.data, loggedIn = _a.loggedIn, user = _a.user, project = _a.project, projectId = _a.projectId;

          if (!loggedIn) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , {
            user: user,
            project: project,
            projectId: projectId
          }];

        case 2:
          err_1 = _b.sent();

          if (err_1.status === 401) {
            return [2
            /*return*/
            , null];
          }

          throw err_1;

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}
/** @hidden */


function getLogoutUrl$$1(httpClient, params) {
  return __awaiter(this, void 0, void 0, function () {
    var response, err_2;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          return [4
          /*yield*/
          , httpClient.get('/logout/url', {
            params: params
          })];

        case 1:
          response = _a.sent();
          return [2
          /*return*/
          , response.data.data.url];

        case 2:
          err_2 = _a.sent();

          if (err_2.status === 401) {
            return [2
            /*return*/
            , null];
          }

          throw err_2;

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}

function clearParametersFromUrl() {
  var params = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    params[_i] = arguments[_i];
  }

  var url = window.location.href;
  params.forEach(function (param) {
    url = removeQueryParameterFromUrl(url, param);
  });
  window.history.replaceState(null, '', url);
}

function generateLoginUrl(params) {
  var project = params.project,
      baseUrl = params.baseUrl,
      redirectUrl = params.redirectUrl,
      errorRedirectUrl = params.errorRedirectUrl;
  var queryParams = {
    project: project,
    redirectUrl: redirectUrl,
    errorRedirectUrl: errorRedirectUrl || redirectUrl
  };
  return baseUrl + "/login/redirect?" + queryString.stringify(queryParams);
}
/** @hidden */


function loginWithRedirect$$1(params) {
  // @ts-ignore we want to return a promise which never gets resolved (window will redirect)
  return new Promise(function () {
    var url = generateLoginUrl(params);
    window.location.assign(url);
  });
}
/** @hidden */


function loginWithPopup$$1(params) {
  return new Promise(function (resolve, reject) {
    var url = generateLoginUrl(params);
    var loginPopup = generatePopupWindow(url, LOGIN_POPUP_NAME);

    if (loginPopup === null) {
      reject(new CogniteLoginError('Failed to create login popup window'));
      return;
    }

    var tokenListener = function tokenListener(message) {
      if (message.source !== loginPopup) {
        return;
      }

      if (!message.data || message.data.error) {
        reject(new CogniteLoginError());
        return;
      }

      window.removeEventListener('message', tokenListener);
      resolve(message.data);
    };

    window.addEventListener('message', tokenListener, false);
  });
}

function isLoginPopupWindow$$1() {
  return window.name === LOGIN_POPUP_NAME;
}

function loginPopupHandler$$1() {
  if (!isLoginPopupWindow$$1()) {
    return;
  }

  try {
    var tokens = parseTokenQueryParameters(window.location.search);
    window.opener.postMessage(tokens);
  } catch (err) {
    window.opener.postMessage({
      error: err.message
    });
  } finally {
    window.close();
  }
}

function isAuthIFrame() {
  return window.name === LOGIN_IFRAME_NAME;
}

function parseTokenQueryParameters(query) {
  var _a = queryString.parse(query),
      _b = ACCESS_TOKEN_PARAM,
      accessToken = _a[_b],
      _c = ID_TOKEN_PARAM,
      idToken = _a[_c],
      _d = ERROR_PARAM,
      error = _a[_d],
      _e = ERROR_DESCRIPTION_PARAM,
      errorDescription = _a[_e];

  if (error !== undefined) {
    throw Error(error + ": " + errorDescription);
  }

  if (lodash.isString(accessToken) && lodash.isString(idToken)) {
    return {
      accessToken: accessToken,
      idToken: idToken
    };
  }

  return null;
}

function extractTokensFromUrl() {
  try {
    var tokens = parseTokenQueryParameters(window.location.search);
    clearParametersFromUrl(ACCESS_TOKEN_PARAM, ID_TOKEN_PARAM);
    return tokens;
  } catch (err) {
    clearParametersFromUrl(ERROR_PARAM, ERROR_DESCRIPTION_PARAM);
    throw err;
  }
}

function silentLogin(params) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , new Promise(function (resolve, reject) {
        var url = generateLoginUrl(params) + "&prompt=none";
        var iframe = createInvisibleIframe(url, LOGIN_IFRAME_NAME);

        iframe.onload = function () {
          try {
            var authTokens = parseTokenQueryParameters(iframe.contentWindow.location.search);

            if (authTokens === null) {
              throw Error('Failed to login');
            }

            resolve(authTokens);
          } catch (e) {
            reject(e);
          } finally {
            document.body.removeChild(iframe);
          }
        };

        document.body.appendChild(iframe);
      })];
    });
  });
}
/** @hidden */


function isTokensValid$$1(httpClient, project, tokens) {
  return __awaiter(this, void 0, void 0, function () {
    var idInfo;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , getIdInfoFromAccessToken$$1(httpClient, tokens.accessToken)];

        case 1:
          idInfo = _a.sent();
          return [2
          /*return*/
          , idInfo !== null && isSameProject(idInfo.project, project)];
      }
    });
  });
}
/** @hidden */


function createAuthenticateFunction$$1(options) {
  var _this = this;

  var project = options.project,
      httpClient = options.httpClient,
      onTokens = options.onTokens,
      onAuthenticate = options.onAuthenticate;
  var baseUrl = getBaseUrl(httpClient.getBaseUrl());
  return promiseCache(function () {
    return __awaiter(_this, void 0, void 0, function () {
      var handleTokens, tokens;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            handleTokens = function handleTokens(tokens) {
              httpClient.setBearerToken(tokens.accessToken);

              if (onTokens) {
                onTokens(tokens);
              }
            };

            return [4
            /*yield*/
            , loginSilently$$1(httpClient, {
              baseUrl: baseUrl,
              project: project
            })];

          case 1:
            tokens = _a.sent();

            if (tokens) {
              handleTokens(tokens);
              return [2
              /*return*/
              , true];
            }

            return [2
            /*return*/
            , new Promise(function (resolve, reject) {
              var login = {
                skip: function skip() {
                  resolve(false);
                },
                redirect: function redirect(params) {
                  var authorizeParams = _assign({
                    baseUrl: baseUrl,
                    project: project
                  }, params);

                  loginWithRedirect$$1(authorizeParams).catch(reject);
                },
                popup: function popup(params) {
                  return __awaiter(_this, void 0, void 0, function () {
                    var authorizeParams;
                    return __generator(this, function (_a) {
                      authorizeParams = _assign({
                        baseUrl: baseUrl,
                        project: project
                      }, params);
                      loginWithPopup$$1(authorizeParams).then(function (tokens) {
                        if (tokens) {
                          handleTokens(tokens);
                          resolve(true);
                        }

                        throw new CogniteLoginError();
                      }).catch(reject);
                      return [2
                      /*return*/
                      ];
                    });
                  });
                }
              };
              onAuthenticate(login);
            })];
        }
      });
    });
  });
}

var version = "2.3.0";
/** @hidden */

var MetadataMap =
/** @class */
function () {
  function MetadataMap() {
    this.map = new WeakMap();
  }

  MetadataMap.prototype.addAndReturn = function (value, metadata) {
    this.map.set(value, {
      // we extract out only what is necessary
      status: metadata.status,
      headers: metadata.headers
    });
    return value;
  };

  MetadataMap.prototype.get = function (value) {
    return this.map.get(value);
  };

  return MetadataMap;
}(); // Copyright 2019 Cognite AS
// polyfill


if (Symbol.asyncIterator === undefined) {
  Symbol.asyncIterator = Symbol.for('asyncIterator');
}
/** @hidden */


function makeAutoPaginationMethods(firstPagePromise) {
  var _a;

  var listPromise = firstPagePromise;
  var i = 0;

  function iterate(listResult) {
    if (i < listResult.items.length) {
      return {
        value: listResult.items[i++],
        done: false
      };
    } else if (listResult.next) {
      // reset counter, request next page, and recurse.
      i = 0;
      listPromise = listResult.next();
      return listPromise.then(iterate);
    }

    return {
      value: undefined,
      done: true
    }; // https://github.com/Microsoft/TypeScript/issues/11375#issuecomment-413037242
  }

  function asyncIteratorNext() {
    return __awaiter(this, void 0, void 0, function () {
      var listResult;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , listPromise];

          case 1:
            listResult = _a.sent();
            return [2
            /*return*/
            , iterate(listResult)];
        }
      });
    });
  }

  var autoPagingEach = makeAutoPagingEach(asyncIteratorNext);
  var autoPagingToArray = makeAutoPagingToArray(autoPagingEach);
  var autoPaginationMethods = (_a = {
    autoPagingEach: autoPagingEach,
    autoPagingToArray: autoPagingToArray,
    // Async iterator functions:
    next: asyncIteratorNext,
    return: function _return() {
      // This is required for `break`.
      return {};
    }
  }, _a[Symbol.asyncIterator] = function () {
    return autoPaginationMethods;
  }, _a);
  return autoPaginationMethods;
}

function makeAutoPagingEach(asyncIteratorNext) {
  return function autoPagingEach(handler) {
    return __awaiter(this, void 0, void 0, function () {
      function iterate() {
        return __awaiter(this, void 0, void 0, function () {
          var iterResult, item, shouldContinue;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , asyncIteratorNext()];

              case 1:
                iterResult = _a.sent();

                if (iterResult.done) {
                  return [2
                  /*return*/
                  ];
                }

                item = iterResult.value;
                return [4
                /*yield*/
                , handler(item)];

              case 2:
                shouldContinue = _a.sent();

                if (shouldContinue === false) {
                  return [2
                  /*return*/
                  ];
                }

                return [4
                /*yield*/
                , iterate()];

              case 3:
                _a.sent();

                return [2
                /*return*/
                ];
            }
          });
        });
      }

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , iterate()];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };
}

function makeAutoPagingToArray(autoPagingEach) {
  return function autoPagingToArray(options) {
    return __awaiter(this, void 0, void 0, function () {
      var limit, items;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            limit = options && options.limit || 25;

            if (limit === -1) {
              limit = Infinity;
            }

            items = [];
            return [4
            /*yield*/
            , autoPagingEach(function (item) {
              return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  items.push(item);

                  if (items.length >= limit) {
                    return [2
                    /*return*/
                    , false];
                  }

                  return [2
                  /*return*/
                  ];
                });
              });
            })];

          case 1:
            _a.sent();

            return [2
            /*return*/
            , items];
        }
      });
    });
  };
} // Copyright 2019 Cognite AS

/** @hidden */


var Queue =
/** @class */
function () {
  function Queue() {
    var _this = this;

    this.add = function (item) {
      _this.data.unshift(item);
    };

    this.remove = function () {
      _this.data.pop();
    };

    this.first = function () {
      return _this.data[0];
    };

    this.last = function () {
      return _this.data[_this.data.length - 1];
    };

    this.size = function () {
      return _this.data.length;
    };

    this.data = [];
  }

  return Queue;
}(); // Copyright 2019 Cognite AS

/** @hidden */


function topologicalSort(nodes) {
  var queue = new Queue();
  var sortedList = [];
  var childrenMap = getChildrenMap(nodes); // insert root nodes

  nodes.forEach(function (node) {
    if (!node.parentNode) {
      queue.add(node);
    }
  });

  while (queue.size() !== 0) {
    var node = queue.last();
    queue.remove();
    sortedList.push(node);
    var children = childrenMap.get(node);

    if (children) {
      children.forEach(queue.add);
    }
  }

  if (sortedList.length !== nodes.length) {
    throw Error('Impossible to topological sort nodes');
  }

  return sortedList;
}

function getChildrenMap(nodes) {
  var childrenMap = new Map();
  nodes.forEach(function (node) {
    childrenMap.set(node, []);
  });
  nodes.forEach(function (node) {
    var parentNode = node.parentNode;

    if (parentNode) {
      childrenMap.get(parentNode).push(node);
    }
  });
  return childrenMap;
}

var CogniteError =
/** @class */
function (_super) {
  __extends(CogniteError, _super);
  /** @hidden */


  function CogniteError(errorMessage, status, requestId, extra) {
    if (extra === void 0) {
      extra = {};
    }

    var _this = this;

    var message = errorMessage + " | code: " + status;

    if (requestId) {
      message += " | X-Request-ID: " + requestId;
    }

    var missing = extra.missing,
        duplicated = extra.duplicated;

    if (missing || duplicated) {
      message += "\n" + JSON.stringify(extra, null, 2);
    }

    _this = _super.call(this, message) || this;
    Object.setPrototypeOf(_this, CogniteError.prototype); // https://stackoverflow.com/questions/51229574/why-instanceof-returns-false-for-a-child-object-in-javascript

    _this.errorMessage = errorMessage;
    _this.status = status;
    _this.requestId = requestId;
    _this.missing = missing;
    _this.duplicated = duplicated;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, _this.constructor);
    } else {
      _this.stack = new Error(message).stack;
    }

    return _this;
  }

  CogniteError.prototype.toJSON = function () {
    var jsonObject = {
      status: this.status,
      message: this.errorMessage
    };

    if (this.requestId) {
      jsonObject.requestId = this.requestId;
    }

    if (this.missing) {
      jsonObject.missing = this.missing;
    }

    if (this.duplicated) {
      jsonObject.duplicated = this.duplicated;
    }

    return jsonObject;
  };

  return CogniteError;
}(Error);
/** @hidden */


function handleErrorResponse(err) {
  var code;
  var message;
  var requestId;
  var missing;
  var duplicated;

  try {
    code = err.status;
    message = err.data.error.message;
    missing = err.data.error.missing;
    duplicated = err.data.error.duplicated;
    requestId = (err.headers || {})[X_REQUEST_ID];
  } catch (_) {
    throw err;
  }

  throw new CogniteError(message, code, requestId, {
    missing: missing,
    duplicated: duplicated
  });
} // Copyright 2019 Cognite AS


var CogniteMultiError =
/** @class */
function (_super) {
  __extends(CogniteMultiError, _super);

  function CogniteMultiError(_a) {
    var e_1, _b;

    var succeded = _a.succeded,
        responses = _a.responses,
        failed = _a.failed,
        errors = _a.errors;

    var _this = _super.call(this, "The API Failed to process some items\n" + JSON.stringify({
      succeded: succeded,
      responses: responses,
      failed: failed,
      errors: errors
    }, null, 2)) || this;

    _this.missing = [];
    _this.duplicated = [];
    _this.statuses = [];
    _this.requestIds = [];
    _this.responses = [];
    Object.setPrototypeOf(_this, CogniteMultiError.prototype); // https://stackoverflow.com/questions/51229574/why-instanceof-returns-false-for-a-child-object-in-javascript

    _this.responses = responses.map(function (response) {
      return response.data;
    });
    _this.errors = errors;
    _this.succeded = succeded.reduce(function (all, current) {
      return all.concat(current);
    }, []);
    _this.failed = failed.reduce(function (all, current) {
      return all.concat(current);
    }, []);
    _this.status = errors[0].status;
    _this.requestId = errors[0].requestId;

    try {
      for (var errors_1 = __values(errors), errors_1_1 = errors_1.next(); !errors_1_1.done; errors_1_1 = errors_1.next()) {
        var err = errors_1_1.value;

        if (err instanceof CogniteError) {
          if (err.missing) {
            _this.missing = _this.missing.concat(err.missing);
          }

          if (err.duplicated) {
            _this.duplicated = _this.duplicated.concat(err.duplicated);
          }

          if (err.requestId) {
            _this.requestIds.push(err.requestId);
          }

          _this.statuses.push(err.status);
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (errors_1_1 && !errors_1_1.done && (_b = errors_1.return)) _b.call(errors_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, _this.constructor);
    } else {
      _this.stack = new Error(_this.message).stack;
    }

    return _this;
  }

  return CogniteMultiError;
}(Error); // Copyright 2019 Cognite AS

/** @hidden */


function enrichAssetsWithTheirParents(assets) {
  var externalIdMap = new Map();
  var nodes = assets.map(function (asset) {
    return {
      data: asset
    };
  }); // find all new exteralIds and map the new externalId to the asset

  nodes.forEach(function (node) {
    var externalId = node.data.externalId;

    if (externalId) {
      externalIdMap.set(externalId, node);
    }
  }); // set correct Node.parentNode

  nodes.forEach(function (node) {
    var parentExternalId = node.data.parentExternalId; // has an internal parent

    if (parentExternalId && externalIdMap.has(parentExternalId)) {
      node.parentNode = externalIdMap.get(parentExternalId);
    }
  });
  return nodes;
}
/** @hidden */


function sortAssetCreateItems(assets) {
  var nodes = enrichAssetsWithTheirParents(assets);
  var sortedNodes = topologicalSort(nodes);
  return sortedNodes.map(function (node) {
    return node.data;
  });
}
/**
 * Resolves all Promises at once, even if some of them fail
 */

/** @hidden */


function promiseAllAtOnce(inputs, promiser) {
  return __awaiter(this, void 0, void 0, function () {
    var failed, succeded, responses, errors, promises, wrappedPromises;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          failed = [];
          succeded = [];
          responses = [];
          errors = [];
          promises = inputs.map(function (input) {
            return promiser(input);
          });
          wrappedPromises = promises.map(function (promise, index) {
            return promise.then(function (result) {
              succeded.push(inputs[index]);
              responses.push(result);
            }).catch(function (error) {
              failed.push(inputs[index]);
              errors.push(error);
            });
          });
          return [4
          /*yield*/
          , Promise.all(wrappedPromises)];

        case 1:
          _a.sent();

          if (failed.length) {
            throw {
              succeded: succeded,
              responses: responses,
              failed: failed,
              errors: errors
            };
          }

          return [2
          /*return*/
          , responses];
      }
    });
  });
}
/** @hidden */
// TODO: refactor


function promiseAllWithData(inputs, promiser, runSequentially) {
  return __awaiter(this, void 0, void 0, function () {
    var err_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 5,, 6]);

          if (!runSequentially) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , promiseEachInSequence(inputs, promiser)];

        case 1:
          return [2
          /*return*/
          , _a.sent()];

        case 2:
          return [4
          /*yield*/
          , promiseAllAtOnce(inputs, promiser)];

        case 3:
          return [2
          /*return*/
          , _a.sent()];

        case 4:
          return [3
          /*break*/
          , 6];

        case 5:
          err_1 = _a.sent();
          throw new CogniteMultiError(err_1);

        case 6:
          return [2
          /*return*/
          ];
      }
    });
  });
}
/**
 * Resolves Promises sequentially
 */

/** @hidden */


function promiseEachInSequence(inputs, promiser) {
  return __awaiter(this, void 0, void 0, function () {
    var _this = this;

    return __generator(this, function (_a) {
      return [2
      /*return*/
      , inputs.reduce(function (previousPromise, input, index) {
        return __awaiter(_this, void 0, void 0, function () {
          var prevResult, _a, _b, err_2;

          return __generator(this, function (_c) {
            switch (_c.label) {
              case 0:
                return [4
                /*yield*/
                , previousPromise];

              case 1:
                prevResult = _c.sent();
                _c.label = 2;

              case 2:
                _c.trys.push([2, 4,, 5]);

                _b = (_a = prevResult).concat;
                return [4
                /*yield*/
                , promiser(input)];

              case 3:
                return [2
                /*return*/
                , _b.apply(_a, [_c.sent()])];

              case 4:
                err_2 = _c.sent();
                throw {
                  errors: [err_2],
                  failed: inputs.slice(index),
                  succeded: inputs.slice(0, index),
                  responses: prevResult
                };

              case 5:
                return [2
                /*return*/
                ];
            }
          });
        });
      }, Promise.resolve(new Array()))];
    });
  });
} // Copyright 2019 Cognite AS


var BaseResourceAPI =
/** @class */
function () {
  function BaseResourceAPI(resourcePath, httpClient, map) {
    var _this = this;

    this.resourcePath = resourcePath;
    this.httpClient = httpClient;
    this.map = map;

    this.callListEndpointWithGet = function (scope) {
      return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.httpClient.get(this.listGetUrl, {
                params: scope
              })];

            case 1:
              response = _a.sent();
              return [2
              /*return*/
              , this.transformResponse(response)];
          }
        });
      });
    };

    this.callListEndpointWithPost = function (scope) {
      return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.httpClient.post(this.listPostUrl, {
                data: scope || {}
              })];

            case 1:
              response = _a.sent();
              return [2
              /*return*/
              , this.transformResponse(response)];
          }
        });
      });
    };
  }

  Object.defineProperty(BaseResourceAPI.prototype, "listGetUrl", {
    get: function get() {
      return this.url('');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BaseResourceAPI.prototype, "listPostUrl", {
    get: function get() {
      return this.url('list');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BaseResourceAPI.prototype, "byIdsUrl", {
    get: function get() {
      return this.url('byids');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BaseResourceAPI.prototype, "updateUrl", {
    get: function get() {
      return this.url('update');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BaseResourceAPI.prototype, "searchUrl", {
    get: function get() {
      return this.url('search');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(BaseResourceAPI.prototype, "deleteUrl", {
    get: function get() {
      return this.url('delete');
    },
    enumerable: true,
    configurable: true
  });

  BaseResourceAPI.chunk = function (items, chunkSize) {
    if (items.length === 0) {
      return [[]];
    }

    return lodash.chunk(items, chunkSize);
  };

  BaseResourceAPI.prototype.getMetadataMap = function () {
    return this.map;
  };

  BaseResourceAPI.prototype.url = function (path) {
    if (path === void 0) {
      path = '';
    }

    return this.resourcePath + '/' + path;
  };

  BaseResourceAPI.prototype.createEndpoint = function (items, path, preRequestModifier, postRequestModifier) {
    if (path === void 0) {
      path = this.url();
    }

    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.callEndpointWithMergeAndTransform(items, function (data) {
          return _this.callCreateEndpoint(data, path);
        }, preRequestModifier, postRequestModifier)];
      });
    });
  };

  BaseResourceAPI.prototype.listEndpoint = function (endpointCaller, scope) {
    var _this = this;

    var listPromise = endpointCaller(scope).then(function (transformedResponse) {
      return _this.addNextPageFunction(endpointCaller.bind(_this), transformedResponse.data, scope);
    });
    var autoPaginationMethods = makeAutoPaginationMethods(listPromise);
    return Object.assign(listPromise, autoPaginationMethods);
  };

  BaseResourceAPI.prototype.retrieveEndpoint = function (ids, path) {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.callEndpointWithMergeAndTransform(ids, function (request) {
          return _this.callRetrieveEndpoint(request, path);
        })];
      });
    });
  };

  BaseResourceAPI.prototype.updateEndpoint = function (changes, path) {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.callEndpointWithMergeAndTransform(changes, function (data) {
          return _this.callUpdateEndpoint(data, path);
        })];
      });
    });
  };

  BaseResourceAPI.prototype.searchEndpoint = function (query) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.callEndpointWithTransform(query, this.callSearchEndpoint)];
      });
    });
  };

  BaseResourceAPI.prototype.deleteEndpoint = function (ids, params, path) {
    return __awaiter(this, void 0, void 0, function () {
      var responses;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.callDeleteEndpoint(ids, params, path)];

          case 1:
            responses = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn({}, responses[0])];
        }
      });
    });
  };

  BaseResourceAPI.prototype.callRetrieveEndpoint = function (ids, path) {
    if (path === void 0) {
      path = this.byIdsUrl;
    }

    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.postInParallelWithAutomaticChunking(path, ids)];
      });
    });
  };

  BaseResourceAPI.prototype.callUpdateEndpoint = function (changes, path) {
    if (path === void 0) {
      path = this.updateUrl;
    }

    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.postInParallelWithAutomaticChunking(path, changes)];
      });
    });
  };

  BaseResourceAPI.prototype.callSearchEndpoint = function (query) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.httpClient.post(this.searchUrl, {
          data: query
        })];
      });
    });
  };

  BaseResourceAPI.prototype.callDeleteEndpoint = function (ids, params, path) {
    if (path === void 0) {
      path = this.deleteUrl;
    }

    return this.postInParallelWithAutomaticChunking(path, ids, params);
  };

  BaseResourceAPI.prototype.addToMapAndReturn = function (response, metadata) {
    return this.map.addAndReturn(response, metadata);
  };

  BaseResourceAPI.prototype.transformAndReturn = function (items, metadata) {
    var transformedResponse = this.transformToClass(items);
    return this.addToMapAndReturn(transformedResponse, metadata);
  };

  BaseResourceAPI.prototype.callEndpointWithMergeAndTransform = function (query, requester, preRequestModifier, postRequestModifier) {
    return __awaiter(this, void 0, void 0, function () {
      var modifiedQuery, responses, mergedResponseItems, modifiedResponseItems;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            modifiedQuery = applyIfApplicable(query, preRequestModifier);
            return [4
            /*yield*/
            , requester.bind(this)(modifiedQuery)];

          case 1:
            responses = _a.sent();
            mergedResponseItems = this.mergeItemsFromItemsResponse(responses);
            modifiedResponseItems = applyIfApplicable(mergedResponseItems, postRequestModifier);
            return [2
            /*return*/
            , this.transformAndReturn(modifiedResponseItems, responses[0])];
        }
      });
    });
  };

  BaseResourceAPI.prototype.callEndpointWithTransform = function (query, requester) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , requester.bind(this)(query)];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , this.transformAndReturn(response.data.items, response)];
        }
      });
    });
  };

  BaseResourceAPI.prototype.mergeItemsFromItemsResponse = function (responses) {
    return responses.map(function (response) {
      return response.data.items;
    }).reduce(function (a, b) {
      return __spread(a, b);
    }, []);
  };

  BaseResourceAPI.prototype.addNextPageFunction = function (endpoint, cursorResponse, query) {
    if (query === void 0) {
      query = {};
    }

    var nextCursor = cursorResponse.nextCursor;
    var next = nextCursor ? function () {
      return endpoint(_assign({}, query, {
        cursor: nextCursor
      })).then(function (response) {
        return response.data;
      });
    } : undefined;
    return _assign({}, cursorResponse, {
      next: next
    });
  };

  BaseResourceAPI.prototype.transformToClass = function (array) {
    return array;
  };

  BaseResourceAPI.prototype.transformToList = function (items) {
    return items;
  };

  BaseResourceAPI.prototype.postInParallelWithAutomaticChunking = function (path, items, params) {
    var _this = this;

    return promiseAllWithData(BaseResourceAPI.chunk(items, 1000), function (singleChunk) {
      return _this.httpClient.post(path, {
        data: _assign({}, params, {
          items: singleChunk
        })
      });
    }, false);
  };

  BaseResourceAPI.prototype.callCreateEndpoint = function (items, path) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.postInSequenceWithAutomaticChunking(path, items)];
      });
    });
  };

  BaseResourceAPI.prototype.transformResponse = function (response) {
    return _assign({}, response, {
      data: _assign({}, response.data, {
        items: this.transformToClass(response.data.items)
      })
    });
  };

  BaseResourceAPI.prototype.postInSequenceWithAutomaticChunking = function (path, items, params) {
    var _this = this;

    return promiseAllWithData(BaseResourceAPI.chunk(items, 1000), function (singleChunk) {
      return _this.httpClient.post(path, {
        data: {
          items: singleChunk
        },
        params: params
      });
    }, true);
  };

  return BaseResourceAPI;
}(); // Copyright 2019 Cognite AS


var AssetMappings3DAPI =
/** @class */
function (_super) {
  __extends(AssetMappings3DAPI, _super);

  function AssetMappings3DAPI() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * [List 3D asset mappings](https://doc.cognitedata.com/api/v1/#operation/get3DMappings)
   *
   * ```js
   * const mappings3D = await client.assetMappings3D.list(3244265346345, 32423454353545);
   * ```
   */


  AssetMappings3DAPI.prototype.list = function (modelId, revisionId, scope) {
    var _this = this;

    var path = this.encodeUrl(modelId, revisionId);
    return _super.prototype.listEndpoint.call(this, function (params) {
      return _this.httpClient.get(path, {
        params: params
      });
    }, scope);
  };
  /**
   * [Create 3D asset mappings](https://doc.cognitedata.com/api/v1/#operation/create3DMappings)
   *
   * ```js
   * const assetMappingsToCreate = [
   *  {
   *    nodeId: 8252999965991682,
   *    assetId: 4354399876978078
   *  },
   *  {
   *    nodeId: 9034285498543958,
   *    assetId: 1042345809544395
   *  }
   * ];
   * const mappings3D = await client.assetMappings3D.create(
   *  25432542356436,
   *  33485743958747,
   *  assetMappingsToCreate
   * );
   * ```
   */


  AssetMappings3DAPI.prototype.create = function (modelId, revisionId, items) {
    var path = this.encodeUrl(modelId, revisionId);
    return _super.prototype.createEndpoint.call(this, items, path);
  };
  /**
   * [Delete a list of asset mappings](https://doc.cognitedata.com/api/v1/#operation/delete3DMappings)
   *
   * ```js
   * const assetMappingsToDelete = [
   *  {
   *    nodeId: 8252999965991682,
   *    assetId: 4354399876978078
   *  },
   *  {
   *    nodeId: 9034285498543958,
   *    assetId: 1042345809544395
   *  }
   * ];
   * await client.assetMappings3D.delete(8252999965991682, 4190022127342195, assetMappingsToDelete);
   * ```
   */


  AssetMappings3DAPI.prototype.delete = function (modelId, revisionId, ids) {
    var path = this.encodeUrl(modelId, revisionId) + '/delete';
    return _super.prototype.deleteEndpoint.call(this, ids, undefined, path);
  };

  AssetMappings3DAPI.prototype.encodeUrl = function (modelId, revisionId) {
    return this.url(modelId + "/revisions/" + revisionId + "/mappings");
  };

  return AssetMappings3DAPI;
}(BaseResourceAPI);

var HttpError =
/** @class */
function (_super) {
  __extends(HttpError, _super);
  /** @hidden */


  function HttpError(status, data, headers) {
    var _this = _super.call(this, "Request failed | status code: " + status) || this;

    _this.status = status;
    _this.data = data;
    _this.headers = headers;
    Object.setPrototypeOf(_this, HttpError.prototype); // https://stackoverflow.com/questions/51229574/why-instanceof-returns-false-for-a-child-object-in-javascript

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, _this.constructor);
    } else {
      _this.stack = new Error(_this.message).stack;
    }

    return _this;
  }

  return HttpError;
}(Error); // Copyright 2019 Cognite AS


var BasicHttpClient =
/** @class */
function () {
  function BasicHttpClient(baseUrl) {
    this.baseUrl = baseUrl;
    this.defaultHeaders = {};
  }

  BasicHttpClient.validateStatusCode = function (status) {
    return status >= 200 && status < 300;
  };

  BasicHttpClient.throwCustomErrorResponse = function (response) {
    throw new HttpError(response.status, response.data, response.headers);
  };

  BasicHttpClient.jsonResponseHandler = function (res) {
    return res.json();
  };

  BasicHttpClient.textResponseHandler = function (res) {
    return res.text();
  };

  BasicHttpClient.arrayBufferResponseHandler = function (res) {
    return res.blob().then(function (blob) {
      return new fetch.Response(blob).arrayBuffer();
    });
  };

  BasicHttpClient.getResponseHandler = function (responseType) {
    switch (responseType) {
      case HttpResponseType.ArrayBuffer:
        return BasicHttpClient.arrayBufferResponseHandler;

      case HttpResponseType.Text:
        return BasicHttpClient.textResponseHandler;

      default:
        return BasicHttpClient.jsonResponseHandler;
    }
  };

  BasicHttpClient.convertFetchHeaders = function (fetchHeaders) {
    var headers = {};
    fetchHeaders.forEach(function (value, key) {
      headers[key] = value;
    });
    return headers;
  };

  BasicHttpClient.transformRequestBody = function (data) {
    var isJSONStringifyable = isJson(data);

    if (isJSONStringifyable) {
      return JSON.stringify(data, null, 2);
    }

    return data;
  };

  BasicHttpClient.prototype.setDefaultHeader = function (name, value) {
    this.defaultHeaders[name] = value;
    return this;
  };

  BasicHttpClient.prototype.setBaseUrl = function (baseUrl) {
    this.baseUrl = baseUrl;
  };

  BasicHttpClient.prototype.getBaseUrl = function () {
    return this.baseUrl;
  };

  BasicHttpClient.prototype.get = function (path, options) {
    if (options === void 0) {
      options = {};
    }

    return this.request(_assign({}, options, {
      path: path,
      method: HttpMethod.Get
    }));
  }; // TODO: responseType -> factory pattern


  BasicHttpClient.prototype.post = function (path, options) {
    if (options === void 0) {
      options = {};
    }

    return this.request(_assign({}, options, {
      path: path,
      method: HttpMethod.Post
    }));
  };

  BasicHttpClient.prototype.put = function (path, options) {
    if (options === void 0) {
      options = {};
    }

    return this.request(_assign({}, options, {
      path: path,
      method: HttpMethod.Put
    }));
  };

  BasicHttpClient.prototype.delete = function (path, options) {
    if (options === void 0) {
      options = {};
    }

    return this.request(_assign({}, options, {
      path: path,
      method: HttpMethod.Delete
    }));
  };

  BasicHttpClient.prototype.preRequest = function (request) {
    return __awaiter(this, void 0, void 0, function () {
      var populatedHeaders;
      return __generator(this, function (_a) {
        populatedHeaders = this.populateDefaultHeaders(request.headers);
        return [2
        /*return*/
        , _assign({}, request, {
          headers: populatedHeaders
        })];
      });
    });
  };

  BasicHttpClient.prototype.postRequest = function (response, _) {
    return __awaiter(this, void 0, void 0, function () {
      var requestIsOk;
      return __generator(this, function (_a) {
        requestIsOk = BasicHttpClient.validateStatusCode(response.status);

        if (!requestIsOk) {
          BasicHttpClient.throwCustomErrorResponse(response);
        }

        return [2
        /*return*/
        , response];
      });
    });
  };

  BasicHttpClient.prototype.populateDefaultHeaders = function (headers) {
    if (headers === void 0) {
      headers = {};
    }

    return _assign({}, this.defaultHeaders, headers);
  };

  BasicHttpClient.prototype.rawRequest = function (request) {
    return __awaiter(this, void 0, void 0, function () {
      var url, headers, body, res, responseHandler, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = this.constructUrl(request.path, request.params);
            headers = _assign({
              Accept: 'application/json'
            }, request.headers);
            body = request.data;

            if (isJson(body)) {
              body = BasicHttpClient.transformRequestBody(body);
              headers['Content-Type'] = 'application/json';
            }

            return [4
            /*yield*/
            , fetch__default(url, {
              body: body,
              method: request.method,
              headers: headers
            })];

          case 1:
            res = _a.sent();
            responseHandler = BasicHttpClient.getResponseHandler(request.responseType);
            return [4
            /*yield*/
            , responseHandler(res)];

          case 2:
            data = _a.sent();
            return [2
            /*return*/
            , {
              headers: BasicHttpClient.convertFetchHeaders(res.headers),
              status: res.status,
              data: data
            }];
        }
      });
    });
  };

  BasicHttpClient.prototype.request = function (request) {
    return __awaiter(this, void 0, void 0, function () {
      var mutatedRequest, rawResponse;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.preRequest(request)];

          case 1:
            mutatedRequest = _a.sent();
            return [4
            /*yield*/
            , this.rawRequest(mutatedRequest)];

          case 2:
            rawResponse = _a.sent();
            return [2
            /*return*/
            , this.postRequest(rawResponse, request)];
        }
      });
    });
  };

  BasicHttpClient.prototype.constructUrl = function (path, params) {
    if (params === void 0) {
      params = {};
    }

    var url = path;
    var hasQueryParams = Object.keys(params).length > 0;

    if (hasQueryParams) {
      url += "?" + queryString.stringify(params);
    }

    return Url.resolve(this.baseUrl, url);
  };

  return BasicHttpClient;
}();

var HttpMethod;

(function (HttpMethod) {
  HttpMethod["Get"] = "get";
  HttpMethod["Post"] = "post";
  HttpMethod["Put"] = "put";
  HttpMethod["Delete"] = "delete";
})(HttpMethod || (HttpMethod = {}));

var HttpResponseType = {
  Json: 'json',
  ArrayBuffer: 'arraybuffer',
  Text: 'text'
}; // Copyright 2019 Cognite AS

var Files3DAPI =
/** @class */
function (_super) {
  __extends(Files3DAPI, _super);

  function Files3DAPI() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * [Retrieve a 3D file"](https://doc.cognitedata.com/api/v1/#operation/get3DFile)
   *
   * ```js
   * await client.files3D.retrieve(3744350296805509);
   * ```
   */


  Files3DAPI.prototype.retrieve = function (fileId) {
    return __awaiter(this, void 0, void 0, function () {
      var path, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.url("" + fileId);
            return [4
            /*yield*/
            , this.httpClient.get(path, {
              responseType: HttpResponseType.ArrayBuffer
            })];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn(response.data, response)];
        }
      });
    });
  };

  return Files3DAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var Models3DAPI =
/** @class */
function (_super) {
  __extends(Models3DAPI, _super);

  function Models3DAPI() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * [Create 3D models](https://doc.cognitedata.com/api/v1/#operation/create3DModels)
   *
   * ```js
   * const modelsToCreate = [
   *   { name: 'Model 0' },
   *   { name: 'Model 2' },
   * ];
   * const models3D = await client.models3D.create(modelsToCreate);
   * ```
   */


  Models3DAPI.prototype.create = function (models) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.createEndpoint.call(this, models)];
      });
    });
  };
  /**
   * [List 3D models](https://doc.cognitedata.com/api/v1/#operation/get3DModels)
   *
   * ```js
   * const models3D = await client.models3D.list({ published: true });
   * ```
   */


  Models3DAPI.prototype.list = function (scope) {
    return _super.prototype.listEndpoint.call(this, this.callListEndpointWithGet, scope);
  };
  /**
   * [Retrieve a 3D model](https://doc.cognitedata.com/api/v1/#operation/get3DModel)
   *
   * ```js
   * await client.models3D.retrieve(3744350296805509);
   * ```
   */


  Models3DAPI.prototype.retrieve = function (id) {
    return __awaiter(this, void 0, void 0, function () {
      var path, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.url("" + id);
            return [4
            /*yield*/
            , this.httpClient.get(path)];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn(response.data, response)];
        }
      });
    });
  };
  /**
   * [Update 3D models](https://doc.cognitedata.com/api/v1/#operation/update3DModels)
   *
   * ```js
   * const modelsToUpdate = [
   *   { id: 3744350296805509, update: { name: { set: 'Model 0 updated' }}},
   *   { id: 8163365893677939, update: { name: { set: 'Model 2 updated' }}},
   * ];
   * const models3D = await client.models3D.update(modelsToUpdate);
   * ```
   */


  Models3DAPI.prototype.update = function (changes) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.updateEndpoint.call(this, changes)];
      });
    });
  };
  /**
   * [Delete 3D models](https://doc.cognitedata.com/api/v1/#operation/delete3DModels)
   *
   * ```js
   * await client.models3D.delete([{ id: 3744350296805509 }, { id: 8163365893677939 }]);
   * ```
   */


  Models3DAPI.prototype.delete = function (ids) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.deleteEndpoint.call(this, ids)];
      });
    });
  };

  return Models3DAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var Nodes3DAPI =
/** @class */
function (_super) {
  __extends(Nodes3DAPI, _super);

  function Nodes3DAPI() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Nodes3DAPI.prototype.list = function (modelId, revisionId, scope) {
    var _this = this;

    var path = this.url(modelId + "/revisions/" + revisionId + "/nodes");
    return _super.prototype.listEndpoint.call(this, function (params) {
      return _this.httpClient.get(path, {
        params: params
      });
    }, scope);
  };

  Nodes3DAPI.prototype.listAncestors = function (modelId, revisionId, nodeId, scope) {
    var _this = this;

    var path = this.url(modelId + "/revisions/" + revisionId + "/nodes/" + nodeId + "/ancestors");
    return _super.prototype.listEndpoint.call(this, function (params) {
      return _this.httpClient.get(path, {
        params: params
      });
    }, scope);
  };

  return Nodes3DAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var Revisions3DAPI =
/** @class */
function (_super) {
  __extends(Revisions3DAPI, _super);

  function Revisions3DAPI(resourcePath, httpClient, map) {
    var _this = _super.call(this, resourcePath, httpClient, map) || this;

    _this.nodes3DApi = new Nodes3DAPI(resourcePath, httpClient, map);
    return _this;
  }
  /**
   * [Create 3D revisions](https://doc.cognitedata.com/api/v1/#operation/create3DRevisions)
   *
   * ```js
   * const revisions = await client.revisions3D.create(4234325345643654, [{ fileId: 8252999965991682 }, { fileId: 6305529564379596 }]);
   * ```
   */


  Revisions3DAPI.prototype.create = function (modelId, items) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.createEndpoint.call(this, items, this.url(modelId + "/revisions"))];
      });
    });
  };
  /**
   * [List 3D revisions](https://doc.cognitedata.com/api/v1/#operation/get3DRevisions)
   *
   * ```js
   * const revisions3D = await client.revisions3D.list(324566546546346);
   * ```
   */


  Revisions3DAPI.prototype.list = function (modelId, filter) {
    var _this = this;

    var path = this.url(modelId + "/revisions");
    return _super.prototype.listEndpoint.call(this, function (params) {
      return _this.httpClient.get(path, {
        params: params
      });
    }, filter);
  };
  /**
   * [Retrieve a 3D revision](https://doc.cognitedata.com/api/v1/#operation/get3DRevision)
   *
   * ```js
   * const revisions3D = await client.revisions3D.retrieve(8252999965991682, 4190022127342195)
   * ```
   */


  Revisions3DAPI.prototype.retrieve = function (modelId, revisionId) {
    return __awaiter(this, void 0, void 0, function () {
      var path, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.url(modelId + "/revisions/" + revisionId);
            return [4
            /*yield*/
            , this.httpClient.get(path)];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn(response.data, response)];
        }
      });
    });
  };
  /**
   * [Update 3D revisions](https://doc.cognitedata.com/api/v1/#operation/update3DRevisions)
   *
   * ```js
   * const revisionsToUpdate = [{
   *  id: 6305529564379596,
   *  update: {
   *    rotation: {
   *      set: [1, 2, 3]
   *    }
   *  }
   * }];
   * const updated = await client.revisions3D.update(8252999965991682, revisionsToUpdate);
   * ```
   */


  Revisions3DAPI.prototype.update = function (modelId, items) {
    return __awaiter(this, void 0, void 0, function () {
      var path;
      return __generator(this, function (_a) {
        path = this.url(modelId + "/revisions/update");
        return [2
        /*return*/
        , _super.prototype.updateEndpoint.call(this, items, path)];
      });
    });
  };
  /**
   * [Delete 3D revisions](https://doc.cognitedata.com/api/v1/#operation/delete3DRevisions)
   *
   * ```js
   * await client.revisions3D.delete(8252999965991682, [{ id: 4190022127342195 }]);
   * ```
   */


  Revisions3DAPI.prototype.delete = function (modelId, ids) {
    return __awaiter(this, void 0, void 0, function () {
      var path;
      return __generator(this, function (_a) {
        path = this.url(modelId + "/revisions/delete");
        return [2
        /*return*/
        , _super.prototype.deleteEndpoint.call(this, ids, undefined, path)];
      });
    });
  };
  /**
   * [Update 3D revision thumbnail](https://docs.cognite.com/api/v1/#operation/updateThumbnail)
   *
   * ```js
   * await client.revisions3D.updateThumbnail(8252999965991682, 4190022127342195, 3243334242324);
   * ```
   */


  Revisions3DAPI.prototype.updateThumbnail = function (modelId, revisionId, fileId) {
    return __awaiter(this, void 0, void 0, function () {
      var path, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.url(modelId + "/revisions/" + revisionId + "/thumbnail");
            return [4
            /*yield*/
            , this.httpClient.post(path, {
              data: {
                fileId: fileId
              }
            })];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn({}, response)];
        }
      });
    });
  };
  /**
   * [List 3D nodes](https://doc.cognitedata.com/api/v1/#operation/get3DNodes)
   *
   * ```js
   * const nodes3d = await client.revisions3D.list3DNodes(8252999965991682, 4190022127342195);
   * ```
   */


  Revisions3DAPI.prototype.list3DNodes = function (modelId, revisionId, query) {
    return this.nodes3DApi.list(modelId, revisionId, query);
  };
  /**
   * [List 3D ancestor nodes](https://doc.cognitedata.com/api/v1/#operation/get3DNodeAncestors)
   *
   * ```js
   * const nodes3d = await client.revisions3D.list3DNodeAncestors(8252999965991682, 4190022127342195, 572413075141081);
   * ```
   */


  Revisions3DAPI.prototype.list3DNodeAncestors = function (modelId, revisionId, nodeId, query) {
    return this.nodes3DApi.listAncestors(modelId, revisionId, nodeId, query);
  };

  return Revisions3DAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var RevealNodes3DAPI =
/** @class */
function (_super) {
  __extends(RevealNodes3DAPI, _super);

  function RevealNodes3DAPI() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  RevealNodes3DAPI.prototype.list = function (modelId, revisionId, scope) {
    var _this = this;

    var path = this.encodeUrl(modelId, revisionId);
    return _super.prototype.listEndpoint.call(this, function (params) {
      return _this.httpClient.get(path, {
        params: params
      });
    }, scope);
  };

  RevealNodes3DAPI.prototype.listAncestors = function (modelId, revisionId, nodeId, scope) {
    var _this = this;

    var path = this.encodeUrl(modelId, revisionId) + ("/" + nodeId + "/ancestors");
    return _super.prototype.listEndpoint.call(this, function (params) {
      return _this.httpClient.get(path, {
        params: params
      });
    }, scope);
  };

  RevealNodes3DAPI.prototype.encodeUrl = function (modelId, revisionId) {
    return this.url("models/" + modelId + "/revisions/" + revisionId + "/nodes");
  };

  return RevealNodes3DAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var RevealRevisions3DAPI =
/** @class */
function (_super) {
  __extends(RevealRevisions3DAPI, _super);

  function RevealRevisions3DAPI() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  RevealRevisions3DAPI.prototype.retrieve = function (modelId, revisionId) {
    return __awaiter(this, void 0, void 0, function () {
      var path, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.url("models/" + modelId + "/revisions/" + revisionId);
            return [4
            /*yield*/
            , this.httpClient.get(path)];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn(response.data, response)];
        }
      });
    });
  };

  return RevealRevisions3DAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var RevealSectors3DAPI =
/** @class */
function (_super) {
  __extends(RevealSectors3DAPI, _super);

  function RevealSectors3DAPI() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  RevealSectors3DAPI.prototype.list = function (modelId, revisionId, scope) {
    var _this = this;

    var path = this.url("models/" + modelId + "/revisions/" + revisionId + "/sectors");
    return _super.prototype.listEndpoint.call(this, function (params) {
      return _this.httpClient.get(path, {
        params: params
      });
    }, scope);
  };

  return RevealSectors3DAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var UnrealRevisions3DAPI =
/** @class */
function (_super) {
  __extends(UnrealRevisions3DAPI, _super);

  function UnrealRevisions3DAPI() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  UnrealRevisions3DAPI.prototype.retrieve = function (modelId, revisionId) {
    return __awaiter(this, void 0, void 0, function () {
      var path, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.url("models/" + modelId + "/revisions/" + revisionId);
            return [4
            /*yield*/
            , this.httpClient.get(path)];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn(response.data, response)];
        }
      });
    });
  };

  return UnrealRevisions3DAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var Viewer3DAPI =
/** @class */
function (_super) {
  __extends(Viewer3DAPI, _super);
  /** @hidden */


  function Viewer3DAPI(resourcePath, httpClient, map) {
    var _this = _super.call(this, resourcePath, httpClient, map) || this;

    var revealPath = resourcePath + '/reveal';
    var unrealPath = resourcePath + '/unreal';
    _this.revealRevisions3DAPI = new RevealRevisions3DAPI(revealPath, httpClient, map);
    _this.revealNodes3DAPI = new RevealNodes3DAPI(revealPath, httpClient, map);
    _this.revealSectors3DAPI = new RevealSectors3DAPI(revealPath, httpClient, map);
    _this.unrealRevisions3DAPI = new UnrealRevisions3DAPI(unrealPath, httpClient, map);
    return _this;
  }
  /**
   * [Retrieve a 3D revision (Reveal)](https://doc.cognitedata.com/api/v1/#operation/getReveal3DRevision)
   *
   * ```js
   * const revisionReveal = await client.viewer3D.retrieveRevealRevision3D(294879032167592, 3247239473298342)
   * ```
   */


  Viewer3DAPI.prototype.retrieveRevealRevision3D = function (modelId, revisionId) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.revealRevisions3DAPI.retrieve(modelId, revisionId)];
      });
    });
  };
  /**
   * [List 3D nodes (Reveal)](https://doc.cognitedata.com/api/v1/#operation/revealGet3DNodes)
   *
   * ```js
   * const nodes3dReveal = await client.viewer3D
   *  .listRevealNodes3D(8252999965991682, 4190022127342195)
   *  .autoPagingToArray();
   * ```
   */


  Viewer3DAPI.prototype.listRevealNodes3D = function (modelId, revisionId, query) {
    return this.revealNodes3DAPI.list(modelId, revisionId, query);
  };
  /**
   * [List 3D ancestor nodes (Reveal)](https://doc.cognitedata.com/api/v1/#operation/revealGet3DNodeAncestors)
   *
   * ```js
   * const ancestorsReveal = await client.viewer3D
   *  .listRevealNode3DAncestors(8252999965991682, 4190022127342195, 120982398890213)
   *  .autoPagingToArray();
   * ```
   */


  Viewer3DAPI.prototype.listRevealNode3DAncestors = function (modelId, revisionId, nodeId, query) {
    return this.revealNodes3DAPI.listAncestors(modelId, revisionId, nodeId, query);
  };
  /**
   * [List 3D sectors (Reveal)](https://doc.cognitedata.com/api/v1/#operation/revealGet3DSectors)
   *
   * ```js
   * const sectors3D = await client.viewer3D
   *  .listRevealSectors3D(8252999965991682, 4190022127342195, { limit: 10 })
   *  .autoPagingToArray();
   * ```
   */


  Viewer3DAPI.prototype.listRevealSectors3D = function (modelId, revisionId, query) {
    return this.revealSectors3DAPI.list(modelId, revisionId, query);
  };
  /**
   * [Retrieve a 3D revision (Unreal)](https://doc.cognitedata.com/api/v1/#operation/getUnreal3DRevision)
   *
   * ```js
   * const revisions3DUnreal = await client.viewer3D.retrieveUnrealRevision3D(8252999965991682, 4190022127342195);
   * ```
   */


  Viewer3DAPI.prototype.retrieveUnrealRevision3D = function (modelId, revisionId) {
    return this.unrealRevisions3DAPI.retrieve(modelId, revisionId);
  };

  return Viewer3DAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var ApiKeysAPI =
/** @class */
function (_super) {
  __extends(ApiKeysAPI, _super);

  function ApiKeysAPI() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * [Create API keys](https://doc.cognitedata.com/api/v1/#operation/createApiKeys)
   *
   * ```js
   * const createdApiKeys = await client.apiKeys.create([{ serviceAccountId: 123 }]);
   * ```
   */


  ApiKeysAPI.prototype.create = function (items) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.createEndpoint(items)];
      });
    });
  };
  /**
   * [List all api keys](https://doc.cognitedata.com/api/v1/#operation/getApiKeys)
   *
   * ```js
   * const apiKeys = await client.apiKeys.list({ all: true });
   * ```
   */


  ApiKeysAPI.prototype.list = function (scope) {
    return __awaiter(this, void 0, void 0, function () {
      var path, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.url();
            return [4
            /*yield*/
            , this.httpClient.get(path, {
              params: scope
            })];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn(response.data.items, response)];
        }
      });
    });
  };
  /**
   * [Delete API keys](https://doc.cognitedata.com/api/v1/#operation/deleteApiKeys)
   *
   * ```js
   * await client.apiKeys.delete([123, 456]);
   * ```
   */


  ApiKeysAPI.prototype.delete = function (ids) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.deleteEndpoint.call(this, ids)];
      });
    });
  };

  return ApiKeysAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var BaseResource =
/** @class */
function () {
  function BaseResource(client, props) {
    this.client = client;
    this.props = props;
  }

  BaseResource.prototype.toJSON = function () {
    return this.props;
  };

  BaseResource.prototype.toString = function () {
    return JSON.stringify(this.props);
  };

  return BaseResource;
}();

var TimeSeries =
/** @class */
function (_super) {
  __extends(TimeSeries, _super);

  function TimeSeries(client, props) {
    var _this = _super.call(this, client, props) || this;
    /**
     * Deletes the current timeseries
     *
     * ```js
     * await timeseries.delete();
     * ```
     */


    _this.delete = function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2
          /*return*/
          , this.client.timeseries.delete([{
            id: this.id
          }])];
        });
      });
    };
    /**
     * Retrieves the asset that the current timeseries is related to
     *
     * ```js
     * const assetList = await timeseries.getAsset();
     * ```
     */


    _this.getAsset = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var assetList;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (this.assetId === undefined) {
                return [2
                /*return*/
                , null];
              }

              return [4
              /*yield*/
              , this.client.assets.retrieve([{
                id: this.assetId
              }])];

            case 1:
              assetList = _a.sent();
              return [2
              /*return*/
              , assetList[0]];
          }
        });
      });
    };
    /**
     * Retrieves all datapoints related to the current timeseries
     *
     * @param {DatapointsMultiQuery} options Query-options for datapoints
     * ```js
     * const datapoints = await timeseries.getDatapoints();
     * ```
     */


    _this.getDatapoints = function (options) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2
          /*return*/
          , this.client.datapoints.retrieve({
            items: [_assign({}, options, {
              id: this.id
            })]
          })];
        });
      });
    };
    /**
     * Retrieves the latest datapoints related to the current timeseries
     *
     * @param {LatestDataPropertyFilter} option Filter-options for latest datapoints
     * ```js
     * const latestDatapoints = await timeseries.getLatestDatapoints();
     * ```
     */


    _this.getLatestDatapoints = function (option) {
      if (option === void 0) {
        option = {};
      }

      return __awaiter(_this, void 0, void 0, function () {
        var filter;
        return __generator(this, function (_a) {
          filter = option;
          return [2
          /*return*/
          , this.client.datapoints.retrieveLatest([_assign({}, filter, {
            id: this.id
          })])];
        });
      });
    };

    return _this;
  }

  Object.defineProperty(TimeSeries.prototype, "externalId", {
    get: function get() {
      return this.props.externalId;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSeries.prototype, "name", {
    get: function get() {
      return this.props.name;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSeries.prototype, "isString", {
    get: function get() {
      return this.props.isString;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSeries.prototype, "metadata", {
    get: function get() {
      return this.props.metadata;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSeries.prototype, "unit", {
    get: function get() {
      return this.props.unit;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSeries.prototype, "assetId", {
    get: function get() {
      return this.props.assetId;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSeries.prototype, "isStep", {
    get: function get() {
      return this.props.isStep;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSeries.prototype, "description", {
    get: function get() {
      return this.props.description;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSeries.prototype, "securityCategories", {
    get: function get() {
      return this.props.securityCategories;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSeries.prototype, "createdTime", {
    get: function get() {
      return this.props.createdTime;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSeries.prototype, "lastUpdatedTime", {
    get: function get() {
      return this.props.lastUpdatedTime;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TimeSeries.prototype, "id", {
    get: function get() {
      return this.props.id;
    },
    enumerable: true,
    configurable: true
  });
  return TimeSeries;
}(BaseResource);

var TimeSeriesList =
/** @class */
function (_super) {
  __extends(TimeSeriesList, _super);

  function TimeSeriesList(client, items) {
    var _this = _super.apply(this, __spread(items)) || this;
    /**
     * Deletes all timeseries in the TimeSeriesList
     * ```js
     * await timeSeriesList.delete();
     * ```
     */


    _this.delete = function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2
          /*return*/
          , this.client.timeseries.delete(this.map(function (timeseries) {
            return {
              id: timeseries.id
            };
          }))];
        });
      });
    };
    /**
     * Retrieves all the assets related to all the timeseries in the TimeSeriesList
     * ```js
     * const assets = await timeSeriesList.getAllAssets();
     * ```
     */


    _this.getAllAssets = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var assetIds;
        return __generator(this, function (_a) {
          assetIds = this.filter(function (timeseries) {
            return timeseries.assetId !== undefined;
          }).map(function (timeseries) {
            return {
              id: timeseries.assetId
            };
          });
          return [2
          /*return*/
          , this.client.assets.retrieve(lodash.uniqBy(assetIds, 'id'))];
        });
      });
    };
    /**
     * Retrieves all the datapoints related to all the timeseries in the TimeSeriesList
     *
     * @param {DatapointsMultiQuery} options Query-options for datapoints
     * ```js
     * const datapoints = await timeSeriesList.getAllDatapoints();
     * ```
     */


    _this.getAllDatapoints = function (options) {
      if (options === void 0) {
        options = {};
      }

      return __awaiter(_this, void 0, void 0, function () {
        var timeseriesIds;
        return __generator(this, function (_a) {
          timeseriesIds = this.map(function (timeseries) {
            return {
              id: timeseries.id
            };
          });
          return [2
          /*return*/
          , this.client.datapoints.retrieve(_assign({
            items: timeseriesIds
          }, options))];
        });
      });
    };

    _this.client = client;
    return _this;
  }

  return TimeSeriesList;
}(Array); // Copyright 2019 Cognite AS


var TimeSeriesAPI =
/** @class */
function (_super) {
  __extends(TimeSeriesAPI, _super);
  /** @hidden */


  function TimeSeriesAPI(client, resourcePath, httpClient, map) {
    var _this = _super.call(this, resourcePath, httpClient, map) || this;

    _this.client = client;
    return _this;
  }
  /**
   * [Create time series](https://doc.cognitedata.com/api/v1/#operation/postTimeSeries)
   *
   * ```js
   * const timeseries = [
   *   { name: 'Pressure sensor', assetId: 123 },
   *   { name: 'Temprature sensor', description: 'Pump abc', unit: 'C' },
   * ];
   * const createdTimeseries = await client.timeseries.create(timeseries);
   * ```
   */


  TimeSeriesAPI.prototype.create = function (items) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.createEndpoint.call(this, items)];
      });
    });
  };
  /**
   * [List time series](https://doc.cognitedata.com/api/v1/#operation/getTimeSeries)
   *
   * ```js
   * const timeseries = await client.timeseries.list({ includeMetadata: false, assetIds: [1, 2] });
   * ```
   */


  TimeSeriesAPI.prototype.list = function (scope) {
    return _super.prototype.listEndpoint.call(this, this.callListEndpointWithGet, scope);
  };
  /**
   * [Retrieve time series](https://doc.cognitedata.com/api/v1/#operation/getTimeSeriesByIds)
   *
   * ```js
   * const timeseries = await client.timeseries.retrieve([
   *   { id: 123 },
   *   { externalId: 'abc' }
   * ]);
   * ```
   */


  TimeSeriesAPI.prototype.retrieve = function (ids) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.retrieveEndpoint.call(this, ids)];
      });
    });
  };
  /**
   * [Update time series](https://doc.cognitedata.com/api/v1/#operation/alterTimeSeries)
   *
   * ```js
   * const timeseries = await client.timeseries.update([{
   *   id: 3785438579439,
   *   update: {
   *     name: { set: 'New name' }
   *   }
   * }]);
   * ```
   */


  TimeSeriesAPI.prototype.update = function (changes) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.updateEndpoint.call(this, changes)];
      });
    });
  };
  /**
   * [Search for time series](https://doc.cognitedata.com/api/v1/#operation/searchTimeSeries)
   *
   * ```js
   * const timeseries = await client.timeseries.search({
   *   filter: {
   *     isString: false,
   *   },
   *   search: {
   *     name: 'Temperature'
   *   }
   * });
   * ```
   */


  TimeSeriesAPI.prototype.search = function (query) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.searchEndpoint.call(this, query)];
      });
    });
  };
  /**
   * [Delete time series](https://doc.cognitedata.com/api/v1/#operation/deleteTimeSeries)
   *
   * ```js
   * await client.timeseries.delete([
   *   { id: 123 },
   *   { externalId: 'abc' }
   * ]);
   * ```
   */


  TimeSeriesAPI.prototype.delete = function (ids) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.deleteEndpoint.call(this, ids)];
      });
    });
  };

  TimeSeriesAPI.prototype.transformToList = function (timeSeries) {
    var _this = this;

    return timeSeries.map(function (timeSerie) {
      return new TimeSeries(_this.client, timeSerie);
    });
  };

  TimeSeriesAPI.prototype.transformToClass = function (timeSeries) {
    var timeseriesArray = this.transformToList(timeSeries);
    return new TimeSeriesList(this.client, timeseriesArray);
  };

  return TimeSeriesAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var AssetList =
/** @class */
function (_super) {
  __extends(AssetList, _super);

  function AssetList(client, items) {
    var _this = _super.apply(this, __spread(items)) || this;
    /**
     * Deletes all assets in the AssetList
     * ```js
     * await assetList.delete();
     * ```
     */


    _this.delete = function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2
          /*return*/
          , this.client.assets.delete(this.map(function (asset) {
            return {
              id: asset.id
            };
          }))];
        });
      });
    };
    /**
     * Return all timeseries for assets in the AssetList
     * ```js
     * const timeseries = await assetList.timeSeries();
     * ```
     */


    _this.timeSeries = function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.getResourcesFromAssets(this.client.timeseries)];

            case 1:
              return [2
              /*return*/
              , _a.sent()];
          }
        });
      });
    };
    /**
     * Return all files for assets in the AssetList
     * ```js
     * const files = await assetList.files();
     * ```
     */


    _this.files = function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.getResourcesFromAssets(this.client.files)];

            case 1:
              return [2
              /*return*/
              , _a.sent()];
          }
        });
      });
    };
    /**
     * Return all events for assets in the AssetList
     * ```js
     * const events = await assetList.events();
     * ```
     */


    _this.events = function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.getResourcesFromAssets(this.client.events)];

            case 1:
              return [2
              /*return*/
              , _a.sent()];
          }
        });
      });
    };

    _this.getResourcesFromAssets = function (accessedApi) {
      return __awaiter(_this, void 0, void 0, function () {
        var e_1, _a, chunks, promises, chunks_1, chunks_1_1, idArray, assetIds, results, responses;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              chunks = this.toChunkedArrayOfIds();
              promises = [];

              try {
                for (chunks_1 = __values(chunks), chunks_1_1 = chunks_1.next(); !chunks_1_1.done; chunks_1_1 = chunks_1.next()) {
                  idArray = chunks_1_1.value;
                  assetIds = {
                    assetIds: idArray
                  };

                  if (accessedApi instanceof TimeSeriesAPI) {
                    promises.push(accessedApi.list(assetIds).autoPagingToArray({
                      limit: Infinity
                    }));
                  } else {
                    promises.push(accessedApi.list({
                      filter: assetIds
                    }).autoPagingToArray({
                      limit: Infinity
                    }));
                  }
                }
              } catch (e_1_1) {
                e_1 = {
                  error: e_1_1
                };
              } finally {
                try {
                  if (chunks_1_1 && !chunks_1_1.done && (_a = chunks_1.return)) _a.call(chunks_1);
                } finally {
                  if (e_1) throw e_1.error;
                }
              }

              return [4
              /*yield*/
              , Promise.all(promises)];

            case 1:
              results = _b.sent();
              responses = [];
              results.forEach(function (result) {
                responses.push.apply(responses, __spread(result));
              });
              return [2
              /*return*/
              , responses];
          }
        });
      });
    };

    _this.toChunkedArrayOfIds = function () {
      var ids = _this.map(function (asset) {
        return asset.id;
      });

      var chunks = [[]];

      if (ids.length) {
        chunks = lodash.chunk(ids, 100);
      }

      return chunks;
    };

    _this.client = client;
    return _this;
  }

  return AssetList;
}(Array); // Copyright 2019 Cognite AS


var Asset =
/** @class */
function (_super) {
  __extends(Asset, _super);

  function Asset(client, props) {
    var _this = _super.call(this, client, props) || this;
    /**
     * Deletes the current asset
     *
     * @param {DeleteOptions} options Allow to delete recursively, default ({}) is recursive = false
     * ```js
     * await asset.delete();
     * ```
     */


    _this.delete = function (options) {
      if (options === void 0) {
        options = {};
      }

      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2
          /*return*/
          , this.client.assets.delete([{
            id: this.id
          }], options)];
        });
      });
    };
    /**
     * Retrieves the parent of the current asset
     * ```js
     * const parentAsset = await asset.parent();
     * ```
     */


    _this.parent = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var _a, parentAsset;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (!this.parentId) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , this.client.assets.retrieve([{
                id: this.parentId
              }])];

            case 1:
              _a = __read.apply(void 0, [_b.sent(), 1]), parentAsset = _a[0];
              return [2
              /*return*/
              , parentAsset];

            case 2:
              return [2
              /*return*/
              , null];
          }
        });
      });
    };
    /**
     * Returns an AssetList object with all children of the current asset
     * ```js
     * const children = await asset.children();
     * ```
     */


    _this.children = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var childAssets;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.client.assets.list({
                filter: {
                  parentIds: [this.id]
                }
              }).autoPagingToArray({
                limit: Infinity
              })];

            case 1:
              childAssets = _a.sent();
              return [2
              /*return*/
              , new AssetList(this.client, childAssets)];
          }
        });
      });
    };
    /**
     * Returns the full subtree of the current asset, including the asset itself
     * @param {SubtreeOptions} options Specify the depth of the required subtree, default is the whole asset-hierarchy
     * ```js
     * const subtree = await asset.subtree();
     * ```
     */


    _this.subtree = function (options) {
      return __awaiter(_this, void 0, void 0, function () {
        var query;
        return __generator(this, function (_a) {
          query = options || {};
          return [2
          /*return*/
          , this.client.assets.retrieveSubtree({
            id: this.id
          }, query.depth || Infinity)];
        });
      });
    };
    /**
     * Returns all timeseries for the current asset
     * @param {TimeseriesFilter} filter Allow specified filter for what timeseries to retrieve
     * ```js
     * const timeSeries = await asset.timeSeries();
     * ```
     */


    _this.timeSeries = function (filter) {
      if (filter === void 0) {
        filter = {};
      }

      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2
          /*return*/
          , this.client.timeseries.list(_assign({}, filter, {
            assetIds: [this.id]
          })).autoPagingToArray({
            limit: Infinity
          })];
        });
      });
    };
    /**
     * Returns all events for the current asset
     * @param {EventFilter} filter Allow specified filter for what events to retrieve
     * ```js
     * const events = await asset.events();
     * ```
     */


    _this.events = function (filter) {
      if (filter === void 0) {
        filter = {};
      }

      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2
          /*return*/
          , this.client.events.list({
            filter: _assign({}, filter, {
              assetIds: [this.id]
            })
          }).autoPagingToArray({
            limit: Infinity
          })];
        });
      });
    };
    /**
     * Returns all files for the current asset
     * @param {FileFilter} filter Allow specified filter for what files to retrieve
     * ```js
     * const files = await asset.files();
     * ```
     */


    _this.files = function (filter) {
      if (filter === void 0) {
        filter = {};
      }

      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2
          /*return*/
          , this.client.files.list({
            filter: _assign({}, filter, {
              assetIds: [this.id]
            })
          }).autoPagingToArray({
            limit: Infinity
          })];
        });
      });
    };

    return _this;
  }

  Object.defineProperty(Asset.prototype, "id", {
    get: function get() {
      return this.props.id;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Asset.prototype, "parentId", {
    get: function get() {
      return this.props.parentId;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Asset.prototype, "name", {
    get: function get() {
      return this.props.name;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Asset.prototype, "description", {
    get: function get() {
      return this.props.description;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Asset.prototype, "metadata", {
    get: function get() {
      return this.props.metadata;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Asset.prototype, "source", {
    get: function get() {
      return this.props.source;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Asset.prototype, "lastUpdatedTime", {
    get: function get() {
      return this.props.lastUpdatedTime;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Asset.prototype, "createdTime", {
    get: function get() {
      return this.props.createdTime;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Asset.prototype, "rootId", {
    get: function get() {
      return this.props.rootId;
    },
    enumerable: true,
    configurable: true
  });
  return Asset;
}(BaseResource); // Copyright 2019 Cognite AS


var RevertableArraySorter =
/** @class */
function () {
  function RevertableArraySorter(sortFunction) {
    var _this = this;

    this.sortFunction = sortFunction;
    this.originalIndexMap = new Map();

    this.sort = function (array) {
      _this.originalIndexMap = new Map();
      _this.originalArray = array;
      array.forEach(function (item, index) {
        _this.originalIndexMap.set(item, index);
      });
      _this.sortedArray = _this.sortFunction(array);
      return _this.sortedArray;
    };

    this.unsort = function (arrayToUnsort) {
      if (!_this.originalArray || !_this.sortedArray) {
        throw Error('Impossible to unsort. Call sort(...) first.');
      }

      if (arrayToUnsort.length !== _this.originalArray.length) {
        throw Error('Impossible to unsort. Input array has a different length from original.');
      }

      var originallySortedArray = [];

      _this.sortedArray.forEach(function (item, index) {
        var originalIndex = _this.originalIndexMap.get(item); // we know it exists


        originallySortedArray[originalIndex] = arrayToUnsort[index];
      });

      return originallySortedArray;
    };
  }

  return RevertableArraySorter;
}(); // Copyright 2019 Cognite AS


var AssetsAPI =
/** @class */
function (_super) {
  __extends(AssetsAPI, _super);
  /** @hidden */


  function AssetsAPI(client, resourcePath, httpClient, map) {
    var _this = _super.call(this, resourcePath, httpClient, map) || this;

    _this.client = client;

    _this.getChildren = function (assets) {
      return __awaiter(_this, void 0, void 0, function () {
        var e_1, _a, ids, chunks, assetsArray, chunks_1, chunks_1_1, chunkOfAssetIds, childrenList, e_1_1;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              ids = assets.map(function (asset) {
                return asset.id;
              });
              chunks = lodash.chunk(ids, 100);
              assetsArray = [];
              _b.label = 1;

            case 1:
              _b.trys.push([1, 6, 7, 8]);

              chunks_1 = __values(chunks), chunks_1_1 = chunks_1.next();
              _b.label = 2;

            case 2:
              if (!!chunks_1_1.done) return [3
              /*break*/
              , 5];
              chunkOfAssetIds = chunks_1_1.value;
              return [4
              /*yield*/
              , this.client.assets.list({
                filter: {
                  parentIds: chunkOfAssetIds
                }
              }).autoPagingToArray({
                limit: Infinity
              })];

            case 3:
              childrenList = _b.sent();
              assetsArray.push.apply(assetsArray, __spread(childrenList));
              _b.label = 4;

            case 4:
              chunks_1_1 = chunks_1.next();
              return [3
              /*break*/
              , 2];

            case 5:
              return [3
              /*break*/
              , 8];

            case 6:
              e_1_1 = _b.sent();
              e_1 = {
                error: e_1_1
              };
              return [3
              /*break*/
              , 8];

            case 7:
              try {
                if (chunks_1_1 && !chunks_1_1.done && (_a = chunks_1.return)) _a.call(chunks_1);
              } finally {
                if (e_1) throw e_1.error;
              }

              return [7
              /*endfinally*/
              ];

            case 8:
              return [2
              /*return*/
              , new AssetList(this.client, assetsArray)];
          }
        });
      });
    };

    return _this;
  }
  /**
   * [Creates new assets](https://doc.cognitedata.com/api/v1/#operation/createAssets)
   *
   * ```js
   * const assets = [
   *   { name: 'First asset' },
   *   { name: 'Second asset', description: 'Another asset', externalId: 'anotherAsset' },
   *   { name: 'Child asset', parentExternalId: 'anotherAsset'},
   * ];
   * const createdAssets = await client.assets.create(assets);
   * ```
   */


  AssetsAPI.prototype.create = function (items) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, sort, unsort;

      return __generator(this, function (_b) {
        _a = new RevertableArraySorter(sortAssetCreateItems), sort = _a.sort, unsort = _a.unsort;
        return [2
        /*return*/
        , _super.prototype.createEndpoint.call(this, items, undefined, sort, unsort)];
      });
    });
  };
  /**
   * [List assets](https://doc.cognitedata.com/api/v1/#operation/listAssets)
   * <!-- or [similar](https://doc.cognitedata.com/api/v1/#operation/getAssets) -->
   *
   * ```js
   * const assets = await client.assets.list({ filter: { name: '21PT1019' } });
   * ```
   */


  AssetsAPI.prototype.list = function (scope) {
    return _super.prototype.listEndpoint.call(this, this.callListEndpointWithPost, scope);
  };
  /**
   * [Retrieve assets](https://doc.cognitedata.com/api/v1/#operation/byIdsAssets)
   * <!-- or [similar](https://doc.cognitedata.com/api/v1/#operation/getAsset) -->
   *
   * ```js
   * const assets = await client.assets.retrieve([{id: 123}, {externalId: 'abc'}]);
   * ```
   */


  AssetsAPI.prototype.retrieve = function (ids) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.retrieveEndpoint.call(this, ids)];
      });
    });
  };
  /**
   * [Update assets](https://doc.cognitedata.com/api/v1/#operation/updateAssets)
   *
   * ```js
   * const assets = await client.assets.update([{id: 123, update: {name: {set: 'New name'}}}]);
   * ```
   */


  AssetsAPI.prototype.update = function (changes) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.updateEndpoint.call(this, changes)];
      });
    });
  };
  /**
   * [Search for assets](https://doc.cognitedata.com/api/v1/#operation/searchAssets)
   *
   * ```js
   * const assets = await client.assets.search({
   *   filter: {
   *     parentIds: [1, 2]
   *   },
   *   search: {
   *     name: '21PT1019'
   *   }
   * });
   * ```
   */


  AssetsAPI.prototype.search = function (query) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.searchEndpoint.call(this, query)];
      });
    });
  };
  /**
   * [Delete assets](https://doc.cognitedata.com/api/v1/#operation/deleteAssets)
   *
   * ```js
   * await client.assets.delete([{id: 123}, {externalId: 'abc'}]);
   * ```
   */


  AssetsAPI.prototype.delete = function (ids, params) {
    if (params === void 0) {
      params = {};
    }

    return __awaiter(this, void 0, void 0, function () {
      var paramsWithIgnoreUnknownIds;
      return __generator(this, function (_a) {
        paramsWithIgnoreUnknownIds = _assign({}, params, {
          ignoreUnknownIds: true
        });
        return [2
        /*return*/
        , _super.prototype.deleteEndpoint.call(this, ids, paramsWithIgnoreUnknownIds)];
      });
    });
  };

  AssetsAPI.prototype.retrieveSubtree = function (id, depth) {
    return __awaiter(this, void 0, void 0, function () {
      var currentDepth, rootAssetList;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            currentDepth = 0;
            return [4
            /*yield*/
            , this.retrieve([id])];

          case 1:
            rootAssetList = _a.sent();
            return [2
            /*return*/
            , this.getAssetSubtree(rootAssetList, currentDepth, depth)];
        }
      });
    });
  };

  AssetsAPI.prototype.transformToList = function (assets) {
    var _this = this;

    return assets.map(function (asset) {
      return new Asset(_this.client, asset);
    });
  };

  AssetsAPI.prototype.transformToClass = function (assets) {
    var assetArray = this.transformToList(assets);
    return new AssetList(this.client, assetArray);
  };

  AssetsAPI.prototype.getAssetSubtree = function (assets, currentDepth, depth) {
    if (depth === void 0) {
      depth = Infinity;
    }

    return __awaiter(this, void 0, void 0, function () {
      var subtree, children, subtreeOfChildren;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            subtree = assets;
            if (!(depth > currentDepth)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , this.getChildren(assets)];

          case 1:
            children = _a.sent();
            if (!(children.length !== 0)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , this.getAssetSubtree(children, currentDepth + 1, depth)];

          case 2:
            subtreeOfChildren = _a.sent();
            subtree.push.apply(subtree, __spread(subtreeOfChildren));
            _a.label = 3;

          case 3:
            return [2
            /*return*/
            , subtree];
        }
      });
    });
  };

  return AssetsAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var DataPointsAPI =
/** @class */
function (_super) {
  __extends(DataPointsAPI, _super);

  function DataPointsAPI() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * [Insert data points](https://doc.cognitedata.com/api/v1/#operation/postMultiTimeSeriesDatapoints)
   *
   * ```js
   * await client.datapoints.insert([{ id: 123, datapoints: [{timestamp: 1557320284000, value: -2}] }]);
   * ```
   */


  DataPointsAPI.prototype.insert = function (items) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.insertEndpoint(items)];
      });
    });
  };
  /**
   * [Retrieve data points](https://doc.cognitedata.com/api/v1/#operation/getMultiTimeSeriesDatapoints)
   *
   * ```js
   * const data = await client.datapoints.retrieve({ items: [{ id: 123 }] });
   * ```
   */


  DataPointsAPI.prototype.retrieve = function (query) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.retrieveDatapointsEndpoint(query)];
      });
    });
  };
  /**
   * [Get latest data point in a time series](https://doc.cognitedata.com/api/v1/#operation/getLatest)
   *
   * ```js
   * const datapoints = await client.datapoints.retrieveLatest([
   *   {
   *    before: 'now',
   *    id: 123
   *  },
   *  {
   *    externalId: 'abc',
   *    before: new Date('21 jan 2018'),
   *  }
   * ]);
   * ```
   */


  DataPointsAPI.prototype.retrieveLatest = function (items) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.retrieveLatestEndpoint(items)];
      });
    });
  };
  /**
   * [Delete data points](https://doc.cognitedata.com/api/v1/#operation/deleteDatapoints)
   *
   * ```js
   * await client.datapoints.delete([{id: 123, inclusiveBegin: new Date('1 jan 2019')}]);
   * ```
   */


  DataPointsAPI.prototype.delete = function (items) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.deleteDatapointsEndpoint(items)];
      });
    });
  };

  DataPointsAPI.prototype.insertEndpoint = function (items) {
    return __awaiter(this, void 0, void 0, function () {
      var path;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.url('data');
            return [4
            /*yield*/
            , this.postInParallelWithAutomaticChunking(path, items)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            , {}];
        }
      });
    });
  };

  DataPointsAPI.prototype.retrieveDatapointsEndpoint = function (query) {
    return __awaiter(this, void 0, void 0, function () {
      var path, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.url('data/list');
            return [4
            /*yield*/
            , this.httpClient.post(path, {
              data: query
            })];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn(response.data.items, response)];
        }
      });
    });
  };

  DataPointsAPI.prototype.retrieveLatestEndpoint = function (items) {
    return __awaiter(this, void 0, void 0, function () {
      var path, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.url('data/latest');
            return [4
            /*yield*/
            , this.httpClient.post(path, {
              data: {
                items: items
              }
            })];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn(response.data.items, response)];
        }
      });
    });
  };

  DataPointsAPI.prototype.deleteDatapointsEndpoint = function (items) {
    return __awaiter(this, void 0, void 0, function () {
      var path;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.url('data/delete');
            return [4
            /*yield*/
            , promiseAllWithData(BaseResourceAPI.chunk(items, 10000), function (singleChunk) {
              return _this.httpClient.post(path, {
                data: {
                  singleChunk: singleChunk
                }
              });
            }, false)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            , {}];
        }
      });
    });
  };

  return DataPointsAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var EventsAPI =
/** @class */
function (_super) {
  __extends(EventsAPI, _super);

  function EventsAPI() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * [Create events](https://doc.cognitedata.com/api/v1/#operation/createEvents)
   *
   * ```js
   * const events = [
   *   { description: 'Workorder pump abc', startTime: new Date('22 jan 2019') },
   *   { description: 'Broken rule', externalId: 'rule123', startTime: 1557346524667000 },
   * ];
   * const createdEvents = await client.events.create(events);
   * ```
   */


  EventsAPI.prototype.create = function (items) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.createEndpoint.call(this, items)];
      });
    });
  };
  /**
   * [List events](https://doc.cognitedata.com/api/v1/#operation/advancedListEvents)
   * <!-- or [similar](https://doc.cognitedata.com/api/v1/#operation/listEvents) -->
   *
   * ```js
   * const events = await client.events.list({ filter: { startTime: { min: new Date('1 jan 2018') }, endTime: { max: new Date('1 jan 2019') } } });
   * ```
   */


  EventsAPI.prototype.list = function (scope) {
    return _super.prototype.listEndpoint.call(this, this.callListEndpointWithPost, scope);
  };
  /**
   * [Retrieve events](https://doc.cognitedata.com/api/v1/#operation/byIdsEvents)
   * <!-- or [similar](https://doc.cognitedata.com/api/v1/#operation/getEventByInternalId) -->
   *
   * ```js
   * const events = await client.events.retrieve([{id: 123}, {externalId: 'abc'}]);
   * ```
   */


  EventsAPI.prototype.retrieve = function (ids) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.retrieveEndpoint.call(this, ids)];
      });
    });
  };
  /**
   * [Update events](https://doc.cognitedata.com/api/v1/#operation/updateEvents)
   *
   * ```js
   * const events = await client.events.update([{id: 123, update: {description: {set: 'New description'}}}]);
   * ```
   */


  EventsAPI.prototype.update = function (changes) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.updateEndpoint.call(this, changes)];
      });
    });
  };
  /**
   * [Search for events](https://doc.cognitedata.com/api/v1/#operation/searchEvents)
   *
   * ```js
   * const events = await client.events.search({
   *   filter: {
   *     assetIds: [1, 2]
   *   },
   *   search: {
   *     description: 'Pump'
   *   }
   * });
   * ```
   */


  EventsAPI.prototype.search = function (query) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.searchEndpoint.call(this, query)];
      });
    });
  };
  /**
   * [Delete events](https://doc.cognitedata.com/api/v1/#operation/deleteEvents)
   *
   * ```js
   * await client.events.delete([{id: 123}, {externalId: 'abc'}]);
   * ```
   */


  EventsAPI.prototype.delete = function (ids) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.deleteEndpoint.call(this, ids)];
      });
    });
  };

  return EventsAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var FilesAPI =
/** @class */
function (_super) {
  __extends(FilesAPI, _super);

  function FilesAPI() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * [Upload a file](https://doc.cognitedata.com/api/v1/#operation/initFileUpload)
   *
   * ```js
   * const fileContent = 'file data here'; // can also be of type ArrayBuffer, Buffer, Blob, File or any
   * // automatic upload:
   * const file = await client.files.upload({name: 'examplefile.jpg', mimeType: 'image/jpg'}, fileContent);
   *
   * // manual with uploadUrl:
   * const file2 = await client.files.upload({name: 'examplefile.jpg', mimeType: 'image/jpg'});
   * // then upload using the file.uploadUrl
   * ```
   */


  FilesAPI.prototype.upload = function (metadata, fileContent, overwrite, waitUntilAcknowledged) {
    if (overwrite === void 0) {
      overwrite = false;
    }

    if (waitUntilAcknowledged === void 0) {
      waitUntilAcknowledged = false;
    }

    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.uploadEndpoint(metadata, fileContent, overwrite, waitUntilAcknowledged)];
      });
    });
  };
  /**
   * [List files](https://doc.cognitedata.com/api/v1/#operation/advancedListFiles)
   * <!-- or [similar](https://doc.cognitedata.com/api/v1/#operation/listFiles) -->
   *
   * ```js
   * const files = await client.files.list({filter: {mimeType: 'image/png'}});
   * ```
   */


  FilesAPI.prototype.list = function (scope) {
    return _super.prototype.listEndpoint.call(this, this.callListEndpointWithPost, scope);
  };
  /**
   * [Retrieve files](https://doc.cognitedata.com/api/v1/#operation/byIdsFiles)
   * <!-- or [just one](https://doc.cognitedata.com/api/v1/#operation/getFileByInternalId) -->
   *
   * ```js
   * const files = await client.files.retrieve([{id: 123}, {externalId: 'abc'}]);
   * ```
   */


  FilesAPI.prototype.retrieve = function (ids) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.retrieveEndpoint.call(this, ids)];
      });
    });
  };
  /**
   * [Update files](https://doc.cognitedata.com/api/v1/#operation/updateFiles)
   *
   * ```js
   * const files = await client.files.update([{
   *   id: 123,
   *   update: {
   *     source: { set: 'new source' }
   *   }
   * }]);
   * ```
   */


  FilesAPI.prototype.update = function (changes) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.updateEndpoint.call(this, changes)];
      });
    });
  };
  /**
   * [Search for files](https://doc.cognitedata.com/api/v1/#operation/searchFiles)
   *
   * ```js
   * const files = await client.files.search({
   *   filter: {
   *     mimeType: 'image/jpg',
   *   },
   *   search: {
   *     name: 'Pump'
   *   }
   * });
   * ```
   */


  FilesAPI.prototype.search = function (query) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.searchEndpoint.call(this, query)];
      });
    });
  };
  /**
   * [Delete files](https://doc.cognitedata.com/api/v1/#operation/deleteFiles)
   *
   * ```js
   * await client.files.delete([{id: 123}, {externalId: 'abc'}]);
   * ```
   */


  FilesAPI.prototype.delete = function (ids) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.deleteEndpoint.call(this, ids)];
      });
    });
  };
  /**
   * [Get download urls](https://doc.cognitedata.com/api/v1/#operation/downloadLinks)
   *
   * ```js
   * await client.files.getDownloadUrls([{id: 123}, {externalId: 'abc'}]);
   * ```
   */


  FilesAPI.prototype.getDownloadUrls = function (ids) {
    return this.getDownloadUrlsEndpoint(ids);
  };

  FilesAPI.prototype.uploadEndpoint = function (metadata, fileContent, overwrite, waitUntilAcknowledged) {
    if (overwrite === void 0) {
      overwrite = false;
    }

    if (waitUntilAcknowledged === void 0) {
      waitUntilAcknowledged = false;
    }

    return __awaiter(this, void 0, void 0, function () {
      var hasFileContent, params, path, response, file, uploadedFile;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            hasFileContent = fileContent != null;

            if (!hasFileContent && waitUntilAcknowledged) {
              throw Error("Don't set waitUntilAcknowledged to true when you are not uploading a file");
            }

            params = {
              overwrite: overwrite
            };
            path = this.url();
            return [4
            /*yield*/
            , this.httpClient.post(path, {
              params: params,
              data: metadata
            })];

          case 1:
            response = _a.sent();
            file = response.data;
            if (!(fileContent != null)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , this.uploadFile(file.uploadUrl, fileContent, metadata.mimeType)];

          case 2:
            _a.sent();

            _a.label = 3;

          case 3:
            if (!waitUntilAcknowledged) return [3
            /*break*/
            , 5];
            return [4
            /*yield*/
            , this.waitUntilFileIsUploaded(file.id)];

          case 4:
            uploadedFile = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn(uploadedFile, response)];

          case 5:
            return [2
            /*return*/
            , this.addToMapAndReturn(file, response)];
        }
      });
    });
  };

  FilesAPI.prototype.uploadFile = function (url, fileContent, mimeType) {
    var headers = {
      'Content-Type': mimeType || 'application/octet-stream'
    };
    return this.httpClient.put(url, {
      headers: headers,
      data: fileContent
    });
  }; // TODO: refactor - similar to RetryableHttpClient.rawRequest


  FilesAPI.prototype.waitUntilFileIsUploaded = function (fileId) {
    return __awaiter(this, void 0, void 0, function () {
      var MAX_RETRIES, DELAY_IN_MS, retryCount, _a, fileInfo;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            MAX_RETRIES = 10;
            DELAY_IN_MS = 500;
            retryCount = 0;
            _b.label = 1;

          case 1:
            return [4
            /*yield*/
            , this.retrieve([{
              id: fileId
            }])];

          case 2:
            _a = __read.apply(void 0, [_b.sent(), 1]), fileInfo = _a[0];

            if (fileInfo.uploaded) {
              return [2
              /*return*/
              , fileInfo];
            }

            retryCount++;
            return [4
            /*yield*/
            , sleepPromise(DELAY_IN_MS)];

          case 3:
            _b.sent();

            _b.label = 4;

          case 4:
            if (retryCount < MAX_RETRIES) return [3
            /*break*/
            , 1];
            _b.label = 5;

          case 5:
            throw Error("File never marked as 'uploaded'");
        }
      });
    });
  };

  FilesAPI.prototype.getDownloadUrlsEndpoint = function (items) {
    return __awaiter(this, void 0, void 0, function () {
      var path, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.url('downloadlink');
            return [4
            /*yield*/
            , this.httpClient.post(path, {
              data: {
                items: items
              }
            })];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn(response.data.items, response)];
        }
      });
    });
  };

  return FilesAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var GroupsAPI =
/** @class */
function (_super) {
  __extends(GroupsAPI, _super);

  function GroupsAPI() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.encodeServiceAccountUrl = function (groupId) {
      return _this.url(groupId + "/serviceaccounts");
    };

    return _this;
  }
  /**
   * [Create groups](https://doc.cognitedata.com/api/v1/#operation/createGroups)
   *
   * ```js
   * const createdGroups = await client.groups.create([{
   *   name: 'Developers',
   *   capabilities: [{
   *     assetsAcl: {
   *       actions: ['LIST'],
   *       scope: { all: {}}
   *     }
   *   }],
   * }]);
   * ```
   */


  GroupsAPI.prototype.create = function (items) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.createEndpoint(items)];
      });
    });
  };
  /**
   * [List groups](https://doc.cognitedata.com/api/v1/#operation/getGroups)
   *
   * ```js
   * const groups = await client.groups.list({ all: true });
   * ```
   */


  GroupsAPI.prototype.list = function (scope) {
    return __awaiter(this, void 0, void 0, function () {
      var path, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.url();
            return [4
            /*yield*/
            , this.httpClient.get(path, {
              params: scope
            })];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn(response.data.items, response)];
        }
      });
    });
  };
  /**
   * [Delete groups](https://doc.cognitedata.com/api/v1/#operation/deleteGroups)
   *
   * ```js
   * await client.groups.delete([921923342342323, 871621872721323]);
   * ```
   */


  GroupsAPI.prototype.delete = function (ids) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.deleteEndpoint.call(this, ids)];
      });
    });
  };
  /**
   * [List service accounts in a group](https://doc.cognitedata.com/api/v1/#operation/getMembersOfGroups)
   *
   * ```js
   * const serviceAccounts = await client.groups.listServiceAccounts(921923342342323);
   * ```
   */


  GroupsAPI.prototype.listServiceAccounts = function (groupId) {
    return __awaiter(this, void 0, void 0, function () {
      var path, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.encodeServiceAccountUrl(groupId);
            return [4
            /*yield*/
            , this.httpClient.get(path)];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn(response.data.items, response)];
        }
      });
    });
  };
  /**
   * [Add service accounts to a group](https://doc.cognitedata.com/api/v1/#operation/addServiceAccountsToGroup)
   *
   * ```js
   * await client.groups.addServiceAccounts(921923342342323, [123312763989213, 23232789217132]);
   * ```
   */


  GroupsAPI.prototype.addServiceAccounts = function (groupId, serviceAccountIds) {
    return __awaiter(this, void 0, void 0, function () {
      var path, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.encodeServiceAccountUrl(groupId);
            return [4
            /*yield*/
            , this.httpClient.post(path, {
              data: {
                items: serviceAccountIds
              }
            })];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn({}, response)];
        }
      });
    });
  };
  /**
   * [Remove service accounts from a group](https://doc.cognitedata.com/api/v1/#operation/removeServiceAccountsFromGroup)
   *
   * ```js
   * await client.groups.removeServiceAccounts(921923342342323, [123312763989213, 23232789217132]);
   * ```
   */


  GroupsAPI.prototype.removeServiceAccounts = function (groupId, serviceAccountIds) {
    return __awaiter(this, void 0, void 0, function () {
      var path, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.encodeServiceAccountUrl(groupId) + '/remove';
            return [4
            /*yield*/
            , this.httpClient.post(path, {
              data: {
                items: serviceAccountIds
              }
            })];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn({}, response)];
        }
      });
    });
  };

  return GroupsAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var LoginAPI =
/** @class */
function (_super) {
  __extends(LoginAPI, _super);
  /** @hidden */


  function LoginAPI(httpClient, map) {
    return _super.call(this, '', httpClient, map) || this;
  }
  /**
   * [Check login status](https://doc.cognitedata.com/api/v1/#operation/status)
   *
   * ```js
   * const status = await client.login.status();
   * // if status === null means you are not logged in
   * ```
   */


  LoginAPI.prototype.status = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , getIdInfo$$1(this.httpClient, {})];
      });
    });
  };

  return LoginAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var LogoutApi =
/** @class */
function (_super) {
  __extends(LogoutApi, _super);
  /** @hidden */


  function LogoutApi(httpClient, map) {
    return _super.call(this, '', httpClient, map) || this;
  }
  /**
   * [Retrieve a logout url](https://docs.cognite.com/api/v1/#operation/logoutUrl)
   *
   * ```js
   * // You can specify the url to send the user to after the logout is successful.
   * // If no url is passed, you will end up at the IDPs log out page.
   * const logoutUrl = await client.logout.getUrl({ redirectUrl: '[url to redirect]' });
   * ```
   */


  LogoutApi.prototype.getUrl = function (options) {
    if (options === void 0) {
      options = {};
    }

    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , getLogoutUrl$$1(this.httpClient, options)];
      });
    });
  };

  return LogoutApi;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var ProjectsAPI =
/** @class */
function (_super) {
  __extends(ProjectsAPI, _super);

  function ProjectsAPI() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * [Retrieve a project](https://doc.cognitedata.com/api/v1/#operation/getProject)
   *
   * ```js
   * const projectInfo = await client.projects.retrieve('publicdata');
   * ```
   */


  ProjectsAPI.prototype.retrieve = function (projectName) {
    return __awaiter(this, void 0, void 0, function () {
      var path, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.encodeUrl(projectName);
            return [4
            /*yield*/
            , this.httpClient.get(path)];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn(response.data, response)];
        }
      });
    });
  };
  /**
   * [Update a project](https://doc.cognitedata.com/api/v1/#operation/putProject)
   *
   * ```js
   * await client.projects.update('new-project-name', {
   *   name: 'New project display name',
   *   defaultGroupId: 123,
   * });
   * ```
   */


  ProjectsAPI.prototype.update = function (projectName, replacement) {
    return __awaiter(this, void 0, void 0, function () {
      var path, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.encodeUrl(projectName);
            return [4
            /*yield*/
            , this.httpClient.put(path, {
              data: replacement
            })];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn(response.data, response)];
        }
      });
    });
  };

  ProjectsAPI.prototype.encodeUrl = function (projectName) {
    return this.url("projects/" + encodeURIComponent(projectName));
  };

  return ProjectsAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var RawRowsAPI =
/** @class */
function (_super) {
  __extends(RawRowsAPI, _super);

  function RawRowsAPI() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  RawRowsAPI.prototype.insert = function (databaseName, tableName, items, ensureParent) {
    if (ensureParent === void 0) {
      ensureParent = false;
    }

    return __awaiter(this, void 0, void 0, function () {
      var path, params;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.encodeUrl(databaseName, tableName) + "/rows";
            params = {
              ensureParent: ensureParent
            };
            return [4
            /*yield*/
            , promiseAllWithData(BaseResourceAPI.chunk(items, 10000), function (singleChunk) {
              return _this.httpClient.post(path, {
                params: params,
                data: {
                  items: singleChunk
                }
              });
            }, false)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            , {}];
        }
      });
    });
  };

  RawRowsAPI.prototype.list = function (databaseName, tableName, scope) {
    var _this = this;

    if (scope === void 0) {
      scope = {};
    }

    var query = {};

    if (scope.onlyRowKeys) {
      query.columns = ',';
    }

    if (scope.columns) {
      query.columns = scope.columns.join(',');
    }

    var path = this.encodeUrl(databaseName, tableName) + "/rows";
    return _super.prototype.listEndpoint.call(this, function (params) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2
          /*return*/
          , this.httpClient.get(path, {
            params: params
          })];
        });
      });
    }, query);
  };

  RawRowsAPI.prototype.retrieve = function (databaseName, tableName, rowKey) {
    return __awaiter(this, void 0, void 0, function () {
      var path, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.encodeUrl(databaseName, tableName) + "/rows/" + encodeURIComponent(rowKey);
            return [4
            /*yield*/
            , this.httpClient.get(path)];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn(response.data, response)];
        }
      });
    });
  };

  RawRowsAPI.prototype.delete = function (databaseName, tableName, items) {
    return __awaiter(this, void 0, void 0, function () {
      var path;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.encodeUrl(databaseName, tableName) + "/rows/delete";
            return [4
            /*yield*/
            , this.postInParallelWithAutomaticChunking(path, items)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            , {}];
        }
      });
    });
  };

  RawRowsAPI.prototype.encodeUrl = function (databaseName, tableName) {
    return this.url(encodeURIComponent(databaseName) + "/tables/" + encodeURIComponent(tableName));
  };

  return RawRowsAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var RawTablesAPI =
/** @class */
function (_super) {
  __extends(RawTablesAPI, _super);

  function RawTablesAPI() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  RawTablesAPI.prototype.create = function (databaseName, items, ensureParent) {
    if (ensureParent === void 0) {
      ensureParent = false;
    }

    return __awaiter(this, void 0, void 0, function () {
      var path, params, responses;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.encodeUrl(databaseName) + "/tables";
            params = {
              ensureParent: ensureParent
            };
            return [4
            /*yield*/
            , promiseAllWithData(BaseResourceAPI.chunk(items, 1000), function (singleChunk) {
              return _this.httpClient.post(path, {
                params: params,
                data: {
                  items: singleChunk
                }
              });
            }, false)];

          case 1:
            responses = _a.sent();
            return [2
            /*return*/
            , this.mergeItemsFromItemsResponse(responses)];
        }
      });
    });
  };

  RawTablesAPI.prototype.list = function (databaseName, scope) {
    var _this = this;

    var path = this.encodeUrl(databaseName) + "/tables";
    return _super.prototype.listEndpoint.call(this, function (params) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2
          /*return*/
          , this.httpClient.get(path, {
            params: params
          })];
        });
      });
    }, scope);
  };

  RawTablesAPI.prototype.delete = function (databaseName, items) {
    return __awaiter(this, void 0, void 0, function () {
      var path;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.encodeUrl(databaseName) + "/tables/delete";
            return [4
            /*yield*/
            , this.postInParallelWithAutomaticChunking(path, items)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            , {}];
        }
      });
    });
  };

  RawTablesAPI.prototype.encodeUrl = function (databaseName) {
    return this.url("" + encodeURIComponent(databaseName));
  };

  return RawTablesAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var RawAPI =
/** @class */
function (_super) {
  __extends(RawAPI, _super);
  /** @hidden */


  function RawAPI(resourcePath, httpClient, map) {
    var _this = _super.call(this, resourcePath, httpClient, map) || this;

    _this.rawTablesApi = new RawTablesAPI(resourcePath, httpClient, map);
    _this.rawRowsApi = new RawRowsAPI(resourcePath, httpClient, map);
    return _this;
  }
  /**
   * [Create databases](https://doc.cognitedata.com/api/v1/#operation/createDBs)
   *
   * ```js
   * const databases = await client.raw.createDatabases([{ name: 'My company' }]);
   * ```
   */


  RawAPI.prototype.createDatabases = function (items) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.createEndpoint.call(this, items)];
      });
    });
  };
  /**
   * [List databases](https://doc.cognitedata.com/api/v1/#operation/getDBs)
   *
   * ```js
   * const databases = await client.raw.listDatabases();
   * ```
   */


  RawAPI.prototype.listDatabases = function (scope) {
    return _super.prototype.listEndpoint.call(this, this.callListEndpointWithGet, scope);
  };
  /**
   * [Delete databases](https://doc.cognitedata.com/api/v1/#operation/deleteDBs)
   *
   * ```js
   * await client.raw.deleteDatabases([{ name: 'My company' }]);
   * ```
   */


  RawAPI.prototype.deleteDatabases = function (items, params) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.deleteEndpoint.call(this, items, params)];
      });
    });
  };
  /**
   * [Create tables in a database](https://doc.cognitedata.com/api/v1/#operation/createTables)
   *
   * ```js
   * const tables = await client.raw.createTables('My company', [{ name: 'Customers' }]);
   * ```
   */


  RawAPI.prototype.createTables = function (databaseName, items, ensureParent) {
    if (ensureParent === void 0) {
      ensureParent = false;
    }

    return this.rawTablesApi.create(databaseName, items, ensureParent);
  };
  /**
   * [List tables in database](https://doc.cognitedata.com/api/v1/#operation/getTables)
   *
   * ```js
   * const tables = await client.raw.listTables('My company');
   * ```
   */


  RawAPI.prototype.listTables = function (databaseName, scope) {
    return this.rawTablesApi.list(databaseName, scope);
  };
  /**
   * [Delete tables in a database](https://doc.cognitedata.com/api/v1/#operation/deleteTables)
   *
   * ```js
   * await client.raw.deleteTables('My company', [{ name: 'Customers' }]);
   * ```
   */


  RawAPI.prototype.deleteTables = function (databaseName, items) {
    return this.rawTablesApi.delete(databaseName, items);
  };
  /**
   * [Insert rows into a table](https://doc.cognitedata.com/api/v1/#operation/postRows)
   *
   * ```js
   * await client.raw.insertRows('My company', 'Customers', [{ key: 'customer1', columns: { 'First name': 'Steve', 'Last name': 'Jobs' } }]);
   * ```
   */


  RawAPI.prototype.insertRows = function (databaseName, tableName, items, ensureParent) {
    if (ensureParent === void 0) {
      ensureParent = false;
    }

    return this.rawRowsApi.insert(databaseName, tableName, items, ensureParent);
  };
  /**
   * [List rows in a table](https://doc.cognitedata.com/api/v1/#operation/getRows)
   *
   * ```js
   * await client.raw.listRows('My company', 'Employees', { columns: ['last_name'] });
   * ```
   */


  RawAPI.prototype.listRows = function (databaseName, tableName, query) {
    return this.rawRowsApi.list(databaseName, tableName, query);
  };
  /**
   * [Retrieve a single row from a table](https://doc.cognitedata.com/api/v1/#operation/getRow)
   *
   * ```js
   * await client.raw.retrieveRow('My company', 'Customers', 'customer1');
   * ```
   */


  RawAPI.prototype.retrieveRow = function (databaseName, tableName, rowKey) {
    return this.rawRowsApi.retrieve(databaseName, tableName, rowKey);
  };
  /**
   * [Delete rows in a table](https://doc.cognitedata.com/api/v1/#operation/deleteRows)
   *
   * ```js
   * await client.raw.deleteRows('My company', 'Customers', [{key: 'customer1'}]);
   * ```
   */


  RawAPI.prototype.deleteRows = function (databaseName, tableName, items) {
    return this.rawRowsApi.delete(databaseName, tableName, items);
  };

  return RawAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var SecurityCategoriesAPI =
/** @class */
function (_super) {
  __extends(SecurityCategoriesAPI, _super);

  function SecurityCategoriesAPI() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * [Create security categories](https://doc.cognitedata.com/api/v1/#operation/createSecurityCategories)
   *
   * ```js
   * const securityCategories = [
   *   { name: 'Admins' },
   *   { name: 'Developers' },
   * ];
   * const createdSecurityCategories = await client.securityCategories.create(securityCategories);
   * ```
   */


  SecurityCategoriesAPI.prototype.create = function (items) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.createEndpoint(items)];
      });
    });
  };
  /**
   * [List security categories](https://doc.cognitedata.com/api/v1/#operation/getSecurityCategories)
   *
   * ```js
   * const securityCategories = await client.securityCategories.list({ sort: 'ASC' });
   * ```
   */


  SecurityCategoriesAPI.prototype.list = function (query) {
    return _super.prototype.listEndpoint.call(this, this.callListEndpointWithGet, query);
  };
  /**
   * [Delete security categories](https://doc.cognitedata.com/api/v1/#operation/deleteSecurityCategories)
   *
   * ```js
   * await client.securityCategories.delete([123, 456]);
   * ```
   */


  SecurityCategoriesAPI.prototype.delete = function (ids) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.deleteEndpoint.call(this, ids)];
      });
    });
  };

  return SecurityCategoriesAPI;
}(BaseResourceAPI); // Copyright 2019 Cognite AS


var ServiceAccountsAPI =
/** @class */
function (_super) {
  __extends(ServiceAccountsAPI, _super);

  function ServiceAccountsAPI() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * [Create service accounts](https://doc.cognitedata.com/api/v1/#operation/createServiceAccounts)
   *
   * ```js
   * const serviceAccounts = [
   *   { name: 'Data extractor' },
   *   { name: 'Monitor', groups: [123, 456] },
   * ];
   * const createdServiceAccounts = await client.serviceAccounts.create(serviceAccounts);
   * ```
   */


  ServiceAccountsAPI.prototype.create = function (items) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.createEndpoint(items)];
      });
    });
  };
  /**
   * [List all service accounts](https://doc.cognitedata.com/api/v1/#operation/getServiceAccounts)
   *
   * ```js
   * const serviceaccounts = await client.serviceAccounts.list();
   * ```
   */


  ServiceAccountsAPI.prototype.list = function () {
    return __awaiter(this, void 0, void 0, function () {
      var path, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            path = this.url();
            return [4
            /*yield*/
            , this.httpClient.get(path)];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , this.addToMapAndReturn(response.data.items, response)];
        }
      });
    });
  };
  /**
   * [Delete service accounts](https://doc.cognitedata.com/api/v1/#operation/deleteServiceAccounts)
   *
   * ```js
   * await client.serviceAccounts.delete([123, 456]);
   * ```
   */


  ServiceAccountsAPI.prototype.delete = function (ids) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , _super.prototype.deleteEndpoint.call(this, ids)];
      });
    });
  };

  return ServiceAccountsAPI;
}(BaseResourceAPI);

var _a;

var MAX_RETRY_ATTEMPTS = 5;
var cdfEndpointsToRetry = (_a = {}, _a[HttpMethod.Post] = ['/assets/list', '/assets/byids', '/assets/search', '/events/list', '/events/byids', '/events/search', '/files/list', '/files/byids', '/files/search', '/files/initupload', '/files/downloadlink', '/timeseries/byids', '/timeseries/search', '/timeseries/data', '/timeseries/data/list', '/timeseries/data/latest', '/timeseries/data/delete'], _a);

var cdfRetryValidator = function cdfRetryValidator(request, response, retryCount) {
  if (retryCount >= MAX_RETRY_ATTEMPTS) {
    return false;
  }

  if (!isValidRetryStatusCode(response.status)) {
    return false;
  }

  if (universalRetryValidator(request, response, retryCount)) {
    return true;
  }

  var endpoints = cdfEndpointsToRetry[request.method] || [];

  if (matchPathWithEndpoints(request.path, endpoints)) {
    return true;
  }

  return false;
};

var universalRetryValidator = function universalRetryValidator(request, response, retryCount) {
  if (retryCount >= MAX_RETRY_ATTEMPTS) {
    return false;
  }

  var httpMethodsToRetry = ['GET', 'HEAD', 'OPTIONS', 'DELETE', 'PUT'];
  var isRetryableHttpMethod = httpMethodsToRetry.indexOf(request.method.toUpperCase()) !== -1;

  if (!isRetryableHttpMethod) {
    return false;
  }

  return isValidRetryStatusCode(response.status);
};

function isValidRetryStatusCode(status) {
  return lodash.inRange(status, 100, 200) || lodash.inRange(status, 429, 430) || lodash.inRange(status, 500, 600);
}

function matchPathWithEndpoints(path, endpoints) {
  return lodash.some(endpoints, function (endpoint) {
    return matchPathWithEndpoint(path, endpoint);
  });
}

function matchPathWithEndpoint(path, endpoint) {
  return path.toUpperCase().indexOf(endpoint.toUpperCase()) !== -1;
}

var RetryableHttpClient =
/** @class */
function (_super) {
  __extends(RetryableHttpClient, _super);

  function RetryableHttpClient(baseUrl, retryValidator) {
    var _this = _super.call(this, baseUrl) || this;

    _this.retryValidator = retryValidator;
    return _this;
  }

  RetryableHttpClient.calculateRetryDelayInMs = function (retryCount) {
    var INITIAL_RETRY_DELAY_IN_MS = 250;
    return INITIAL_RETRY_DELAY_IN_MS + (Math.pow(2, retryCount) - 1) / 2 * 1000;
  };

  RetryableHttpClient.prototype.rawRequest = function (request) {
    return __awaiter(this, void 0, void 0, function () {
      var retryCount, response, shouldRetry, delayInMs;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            retryCount = 0;
            _a.label = 1;

          case 1:
            return [4
            /*yield*/
            , _super.prototype.rawRequest.call(this, request)];

          case 2:
            response = _a.sent();
            shouldRetry = this.retryValidator(request, response, retryCount);

            if (!shouldRetry) {
              return [2
              /*return*/
              , response];
            }

            delayInMs = RetryableHttpClient.calculateRetryDelayInMs(retryCount);
            return [4
            /*yield*/
            , sleepPromise(delayInMs)];

          case 3:
            _a.sent();

            retryCount++;
            _a.label = 4;

          case 4:
            return [3
            /*break*/
            , 1];
            _a.label = 5;

          case 5:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return RetryableHttpClient;
}(BasicHttpClient); // Copyright 2019 Cognite AS


var CDFHttpClient =
/** @class */
function (_super) {
  __extends(CDFHttpClient, _super);

  function CDFHttpClient(baseUrl) {
    var _this = _super.call(this, baseUrl, cdfRetryValidator) || this;

    _this.response401Handler = function (_, __, reject) {
      return reject();
    };

    return _this;
  }

  CDFHttpClient.serializeQueryParameters = function (params) {
    if (params === void 0) {
      params = {};
    }

    return Object.keys(params).reduce(function (serializedParams, key) {
      var param = params[key];
      serializedParams[key] = isJson(param) ? JSON.stringify(param) : param;
      return serializedParams;
    }, {});
  };

  CDFHttpClient.transformDateInResponse = function (response) {
    var data = response.data;

    if (!isJson(data)) {
      return response;
    }

    return _assign({}, response, {
      data: transformDateInResponse(data)
    });
  };

  CDFHttpClient.isSameOrigin = function (baseUrl, url) {
    var _a = Url.parse(baseUrl),
        baseUrlProtocol = _a.protocol,
        baseUrlHost = _a.host;

    var _b = Url.parse(Url.resolve(baseUrl, url)),
        protocol = _b.protocol,
        host = _b.host;

    var hasSameProtocol = baseUrlProtocol === protocol;
    var hasSameHost = baseUrlHost === host;
    return hasSameProtocol && hasSameHost;
  };

  CDFHttpClient.filterHeaders = function (headers, names) {
    return names.reduce(function (partiallyFilteredHeaders, headerName) {
      return CDFHttpClient.filterHeader(partiallyFilteredHeaders, headerName);
    }, headers);
  };

  CDFHttpClient.filterHeader = function (headers, name) {
    var filteredHeaders = _assign({}, headers);

    delete filteredHeaders[name];
    return filteredHeaders;
  };

  CDFHttpClient.prototype.setBearerToken = function (token) {
    this.setDefaultHeader(AUTHORIZATION_HEADER, bearerString(token));
  };

  CDFHttpClient.prototype.set401ResponseHandler = function (handler) {
    this.response401Handler = handler;
  };

  CDFHttpClient.prototype.preRequest = function (request) {
    return __awaiter(this, void 0, void 0, function () {
      var headersWithDefaultHeaders, headers, data, serializedQueryParams, params;
      return __generator(this, function (_a) {
        headersWithDefaultHeaders = this.populateDefaultHeaders(request.headers);
        headers = this.preventTokenLeakage(headersWithDefaultHeaders, request.path);
        data = transformDateInRequest(request.data);
        serializedQueryParams = CDFHttpClient.serializeQueryParameters(request.params);
        params = transformDateInRequest(serializedQueryParams);
        return [2
        /*return*/
        , _assign({}, request, {
          data: data,
          headers: headers,
          params: params
        })];
      });
    });
  };

  CDFHttpClient.prototype.postRequest = function (response, request) {
    return __awaiter(this, void 0, void 0, function () {
      var transformedResponse, err_1;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            transformedResponse = CDFHttpClient.transformDateInResponse(response);
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , _super.prototype.postRequest.call(this, transformedResponse, request)];

          case 2:
            return [2
            /*return*/
            , _a.sent()];

          case 3:
            err_1 = _a.sent();

            if (err_1.status === 401 && !this.isLoginOrLogoutApi(request.path)) {
              return [2
              /*return*/
              , new Promise(function (resolvePromise, rejectPromise) {
                var retry = function retry() {
                  return resolvePromise(_this.request(request));
                };

                var reject = function reject() {
                  return rejectPromise(err_1);
                };

                _this.response401Handler(err_1, retry, reject);
              })];
            }

            throw handleErrorResponse(err_1);

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  CDFHttpClient.prototype.preventTokenLeakage = function (headers, path) {
    if (CDFHttpClient.isSameOrigin(this.baseUrl, path)) {
      return headers;
    }

    return CDFHttpClient.filterHeaders(headers, [AUTHORIZATION_HEADER, API_KEY_HEADER, X_CDF_APP_HEADER, X_CDF_SDK_HEADER]);
  };

  CDFHttpClient.prototype.isLoginOrLogoutApi = function (url) {
    var lowerCaseUrl = url.toLowerCase();
    return lowerCaseUrl.indexOf('/logout/url') !== -1 || lowerCaseUrl.indexOf('/login/status') !== -1;
  };

  return CDFHttpClient;
}(RetryableHttpClient); // Copyright 2019 Cognite AS


var REDIRECT = 'REDIRECT';
var POPUP = 'POPUP';

function validateAndReturnAPI(api) {
  if (api === undefined) {
    throw Error('Need to login with either loginWithApiKey or loginWithOAuth before you can use the Cognite SDK');
  }

  return api;
}

function throwReLogginError() {
  throw Error('You cannot re-login with an already logged in Cognite client instance. Try to create a new Cognite client instance instead.');
}

var CogniteClient =
/** @class */
function () {
  /**
   * Create a new SDK client
   *
   * @param options Client options
   *
   * ```js
   * import { CogniteClient } from '@cognite/sdk';
   *
   * const client = new CogniteClient({ appId: 'YOUR APPLICATION NAME' });
   *
   * // can also specify a base URL
   * const client = new CogniteClient({ ..., baseUrl: 'https://greenfield.cognitedata.com' });
   * ```
   */
  function CogniteClient(options) {
    var _this = this;

    this.projectName = '';
    this.hasBeenLoggedIn = false; // tslint:disable-next-line:no-identical-functions

    this.authenticate = function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          throw Error('You can only call authenticate after you have called loginWithOAuth');
        });
      });
    };
    /**
     * Login client with api-key
     *
     * @param options Login options
     *
     * ```js
     * import { CogniteClient } from '@cognite/sdk';
     *
     * const client = new CogniteClient({ appId: '[YOUR APP NAME]' });
     * client.loginWithApiKey({
     *   apiKey: '[API KEY]',
     *   project: '[PROJECT]',
     * });
     * // after login you can do calls with the client
     * const createdAsset = await client.assets.create([{ name: 'My first asset' }]);
     * ```
     */


    this.loginWithApiKey = function (options) {
      if (_this.hasBeenLoggedIn) {
        throwReLogginError();
      }

      if (!lodash.isObject(options)) {
        throw Error('`loginWithApiKey` is missing parameter `options`');
      }

      var project = options.project,
          apiKey = options.apiKey;
      ['project', 'apiKey'].forEach(function (property) {
        // @ts-ignore
        if (!lodash.isString(options[property])) {
          throw Error("options." + property + " is required and must be of type string");
        }
      });
      _this.projectName = project;

      _this.httpClient.setDefaultHeader(API_KEY_HEADER, apiKey);

      _this.initAPIs();
    };
    /**
     * Login client with OAuth login flow
     * <!-- [Login with redirect](https://doc.cognitedata.com/api/v1/#operation/redirectUrl) -->
     *
     * ```js
     * import { CogniteClient, REDIRECT } from '@cognite/sdk';
     *
     * const client = new CogniteClient({ appId: '[YOUR APP NAME]' });
     *
     * client.loginWithOAuth({
     *   project: '[PROJECT]',
     *   onAuthenticate: REDIRECT // optional, REDIRECT is by default
     * });
     * // after login you can do calls with the client
     * (async () => {
     *   const createdAsset = await client.assets.create([{ name: 'My first asset' }]);
     * })();
     * ```
     *
     * @param options Login options
     */


    this.loginWithOAuth = function (options) {
      if (_this.hasBeenLoggedIn) {
        throwReLogginError();
      }

      if (!lodash.isObject(options)) {
        throw Error('`loginWithOAuth` is missing parameter `options`');
      }

      var project = options.project;

      if (!lodash.isString(project)) {
        throw Error('options.project is required and must be of type string');
      }

      _this.projectName = project;

      var onTokens = options.onTokens || function () {};

      var onAuthenticate = options.onAuthenticate === POPUP ? onAuthenticateWithPopup : lodash.isFunction(options.onAuthenticate) ? options.onAuthenticate : onAuthenticateWithRedirect;
      var authenticate = createAuthenticateFunction$$1({
        project: project,
        httpClient: _this.httpClient,
        onAuthenticate: onAuthenticate,
        onTokens: onTokens
      });

      _this.httpClient.set401ResponseHandler(function (_, retry, reject) {
        return __awaiter(_this, void 0, void 0, function () {
          var didAuthenticate;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , authenticate()];

              case 1:
                didAuthenticate = _a.sent();
                return [2
                /*return*/
                , didAuthenticate ? retry() : reject()];
            }
          });
        });
      });

      var accessToken = options.accessToken;

      if (accessToken) {
        _this.httpClient.setBearerToken(accessToken);
      }

      _this.initAPIs();

      _this.authenticate = authenticate;
    };
    /**
     * To modify the base-url at any point in time
     */


    this.setBaseUrl = function (baseUrl) {
      _this.httpClient.setBaseUrl(baseUrl);
    };
    /**
     * Lookup response metadata from an request using the response as the parameter
     *
     * ```js
     * const createdAsset = await client.assets.create([{ name: 'My first asset' }]);
     * const metadata = client.getMetadata(createdAsset);
     * ```
     */


    this.getMetadata = function (value) {
      return _this.metadataMap.get(value);
    };
    /**
     * Basic HTTP method for GET
     *
     * @param path The URL path
     * @param options Request options, optional
     *
     * ```js
     * const response = await client.get('/api/v1/projects/{project}/assets', { params: { limit: 50 }});
     * ```
     */


    this.get = function (path, options) {
      return _this.httpClient.get(path, options);
    };
    /**
     * Basic HTTP method for PUT
     *
     * @param path The URL path
     * @param options Request options, optional
     *
     * ```js
     * const response = await client.put('someUrl');
     * ```
     */


    this.put = function (path, options) {
      return _this.httpClient.put(path, options);
    };
    /**
     * Basic HTTP method for POST
     *
     * @param path The URL path
     * @param options Request options, optional
     *
     * ```js
     * const assets = [{ name: 'First asset' }, { name: 'Second asset' }];
     * const response = await client.post('/api/v1/projects/{project}/assets', { data: { items: assets } });
     * ```
     */


    this.post = function (path, options) {
      return _this.httpClient.post(path, options);
    };
    /**
     * Basic HTTP method for DELETE
     *
     * @param path The URL path
     * @param options Request options, optional
     * ```js
     * const response = await client.delete('someUrl');
     * ```
     */


    this.delete = function (path, options) {
      return _this.httpClient.delete(path, options);
    };

    this.initAPIs = function () {
      var defaultArgs = [_this.httpClient, _this.metadataMap];
      var projectPath = projectUrl(_this.project);

      var apiFactory = function apiFactory(api, relativePath) {
        return new (api.bind.apply(api, __spread([void 0, projectPath + relativePath], defaultArgs)))();
      };

      var models3DPath = '/3d/models';
      _this.assetsApi = new (AssetsAPI.bind.apply(AssetsAPI, __spread([void 0, _this, projectPath + '/assets'], defaultArgs)))();
      _this.timeSeriesApi = new (TimeSeriesAPI.bind.apply(TimeSeriesAPI, __spread([void 0, _this, projectPath + '/timeseries'], defaultArgs)))();
      _this.dataPointsApi = apiFactory(DataPointsAPI, '/timeseries');
      _this.eventsApi = apiFactory(EventsAPI, '/events');
      _this.filesApi = apiFactory(FilesAPI, '/files');
      _this.rawApi = apiFactory(RawAPI, '/raw/dbs');
      _this.groupsApi = apiFactory(GroupsAPI, '/groups');
      _this.securityCategoriesApi = apiFactory(SecurityCategoriesAPI, '/securitycategories');
      _this.serviceAccountsApi = apiFactory(ServiceAccountsAPI, '/serviceaccounts');
      _this.apiKeysApi = apiFactory(ApiKeysAPI, '/apikeys');
      _this.models3DApi = apiFactory(Models3DAPI, models3DPath);
      _this.revisions3DApi = apiFactory(Revisions3DAPI, models3DPath);
      _this.files3DApi = apiFactory(Files3DAPI, '/3d/files');
      _this.assetMappings3DApi = apiFactory(AssetMappings3DAPI, models3DPath);
      _this.viewer3DApi = apiFactory(Viewer3DAPI, '/3d');
      _this.projectsApi = new (ProjectsAPI.bind.apply(ProjectsAPI, __spread([void 0, apiUrl()], defaultArgs)))();
      _this.loginApi = new (LoginAPI.bind.apply(LoginAPI, __spread([void 0], defaultArgs)))();
    };

    if (!lodash.isObject(options)) {
      throw Error('`CogniteClient` is missing parameter `options`');
    }

    if (!lodash.isString(options.appId)) {
      throw Error('options.appId is required and must be of type string');
    }

    var baseUrl = options.baseUrl;
    this.httpClient = new CDFHttpClient(getBaseUrl(baseUrl));
    this.httpClient.setDefaultHeader(X_CDF_SDK_HEADER, "CogniteJavaScriptSDK:" + version).setDefaultHeader(X_CDF_APP_HEADER, options.appId);
    this.metadataMap = new MetadataMap();
    this.loginApi = new LoginAPI(this.httpClient, this.metadataMap);
    this.logoutApi = new LogoutApi(this.httpClient, this.metadataMap);
  }

  Object.defineProperty(CogniteClient.prototype, "assets", {
    get: function get() {
      return validateAndReturnAPI(this.assetsApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "timeseries", {
    get: function get() {
      return validateAndReturnAPI(this.timeSeriesApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "datapoints", {
    get: function get() {
      return validateAndReturnAPI(this.dataPointsApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "events", {
    get: function get() {
      return validateAndReturnAPI(this.eventsApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "files", {
    get: function get() {
      return validateAndReturnAPI(this.filesApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "raw", {
    get: function get() {
      return validateAndReturnAPI(this.rawApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "projects", {
    get: function get() {
      return validateAndReturnAPI(this.projectsApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "groups", {
    get: function get() {
      return validateAndReturnAPI(this.groupsApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "securityCategories", {
    get: function get() {
      return validateAndReturnAPI(this.securityCategoriesApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "serviceAccounts", {
    get: function get() {
      return validateAndReturnAPI(this.serviceAccountsApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "models3D", {
    get: function get() {
      return validateAndReturnAPI(this.models3DApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "revisions3D", {
    get: function get() {
      return validateAndReturnAPI(this.revisions3DApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "files3D", {
    get: function get() {
      return validateAndReturnAPI(this.files3DApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "assetMappings3D", {
    get: function get() {
      return validateAndReturnAPI(this.assetMappings3DApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "viewer3D", {
    get: function get() {
      return validateAndReturnAPI(this.viewer3DApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "apiKeys", {
    get: function get() {
      return validateAndReturnAPI(this.apiKeysApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "login", {
    get: function get() {
      return this.loginApi;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "logout", {
    get: function get() {
      return this.logoutApi;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "project", {
    get: function get() {
      return this.projectName;
    },
    enumerable: true,
    configurable: true
  });
  return CogniteClient;
}();

function onAuthenticateWithRedirect(login) {
  login.redirect({
    redirectUrl: window.location.href
  });
}

function onAuthenticateWithPopup(login) {
  login.popup({
    redirectUrl: window.location.href
  });
} // Copyright 2019 Cognite AS


exports.loginPopupHandler = loginPopupHandler$$1;
exports.isLoginPopupWindow = isLoginPopupWindow$$1;
exports.CogniteClient = CogniteClient;
exports.POPUP = POPUP;
exports.REDIRECT = REDIRECT;